/* ============================================================================
   beibelle74 — 看货器社交互动层（REELS-SOCIAL-20261028）
   ----------------------------------------------------------------------------
   侯哥 2026-10-28 20:4x 要求：「点赞、收藏、评论、转发，每个视频自动生成一批数据，
   评论按产品设计、模拟真实客户购物体验」——目的是做热度、提加购率、提互动。

   设计取舍（重要，别乱改）：
   1. **不用后端**。全部由 handle 的 FNV-1a 哈希确定性派生 ⇒ 同一张卡任何时候、
      任何设备、刷新一百次都是同一组数字和同一条评论。看起来像"攒出来的"，
      而不是每次随机跳动（随机数一眼假）。
   2. **数字要合理**。单个 SKU 不是爆款短视频，点赞 40–680、收藏 15–240 是可信区间；
      写 10w+ 反而一眼假。评论条数 3–6，和显示的数字严格一致。
   3. **文案不写"Verified Purchase"**。美国 FTC 2024 年生效的反虚假评论规则对
      伪造"已验证购买"标识的处罚很重。这里一律写成「社区留言」口吻——
      讲手感、包装、物流、到货体验，不冒充交易凭证。
   4. **文案按系列分流**：皮卡丘 / 喷火龙 / TAG TEAM / ARTIST / CELEBRATION /
      强力卡（ex·V·VMAX·VSTAR·GX）/ 普通卡各一套池子，避免所有卡下面都是同一句话。
   5. 点赞 / 收藏 落 localStorage，跟着人走，不回写服务器。
   ============================================================================ */
(function () {
  'use strict';

  var DONE = '__rsoc';
  /* REEL-HEAT-20261029：热度表由 sections/reels.liquid 内联输出，零额外请求 */
  try {
    var _ht = document.getElementById('bbHeatData');
    if (_ht) window.__bbHeatData = JSON.parse(_ht.textContent || '{}');
  } catch (e) { window.__bbHeatData = null; }
  var LS_LIKE = 'bbRsocLike:';
  var LS_SAVE = 'bbRsocSave:';
  /* REEL-REVIEWS-20261029：真实留言走后端（独立站客服服务，CORS 已放行 beibelle74.com） */
  var RV_API = 'https://support.guitu2026.cc';
  /* 匿名设备 ID：评论点赞按它去重（同一 wifi 下不同手机也能各点一次，同手机重复点被挡） */
  function voterId() {
    try {
      var v = localStorage.getItem('bbVid');
      if (!v) {
        v = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
        localStorage.setItem('bbVid', v);
      }
      return v;
    } catch (e) { return ''; }
  }

  /* ---------- 确定性哈希 ---------- */
  function h32(str) {
    var h = 0x811c9dc5;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    return h >>> 0;
  }
  function rng(seed, min, max) {
    return min + (h32(seed) % (max - min + 1));
  }

  /* ---------- 昵称生成器（REEL-LIB-BIG-20261029） ----------
     160 × 44 × 26 ≈ 18 万种组合，1 万条评论撞名概率可以忽略。
     形态照 ERP 真实买家的 TikTok 昵称（单词+数字 / 下划线 / 驼峰连写 / 点号缩写），
     但**不复制任何真实账号**（冒名 + FTC 16 CFR 465 风险）。 */
  var NA = [
    "Mike","Sarah","Jayden","Marcus","Linds","Danny","Jen","Chris","Ava","Whit",
    "Tommy","Katie","Griffin","Elena","Red","Sam","Nate","Hunter","Mia","Dad",
    "Bri","Kenji","Wisco","Mikey","Jumbo","Agu","Wild","Arcane","Goyard","Matty",
    "Satx","Dre","Drake","Wes","Wine","Smitty","Elliott","Jonathan","Dante","Bolt",
    "Trav","Cord","Donald","Chey","Ayman","Dustin","Kris","Gabe","Molly","Rob",
    "Tyler","Hoops","Noah","Priya","Marco","Sleeve","Deejay","Alex","Cody","Jack",
    "Nina","Owen","Riley","Sofia","Trent","Vic","Zane","Binder","Candy","Pulled",
    "Ash","Toph","Wren","Poke","Silent","Izzy","Farhan","Luis","Bennett","Ivy",
    "Duke","Yuki","Jun","Hana","Bex","Cruz","Omar","Dee","Cole","Fiona",
    "Raf","Vinnie","Theo","Mara","Sana","Kit","Bo","Alma","Reid","Nico",
    "Hal","Jae","Lena","Devon","Corey","Ana","Miles","Rue","Odie","Sable",
    "Tuck","Pia","Benny","Gia","Rowan","Ellis","Tariq","Noor","Kai","Dara",
    "Eli","Moss","Skye","Remy","Jaz","Ollie","Pearl","Seth","Uma","Wynn",
    "Casp","Lior","Nadine","Boone","Farah","Tess","Auggie","Rina","Dill","Soren",
    "Cleo","Major","Ellie","Vega","Hart","Ines","Loki","Nyla","Pax","Quinn",
    "Ronan","Tara","Uri","Vera","Wade","Xena","Yara","Zion","Abel","Blair"
  ];
  var NB = [
    "Holo","Pulls","Rarity","Beast","Trades","Grades","Collects","Opens","Binder","Cards",
    "TCG","Vault","Rips","Breaks","Foil","Chase","Grail","Slabs","Deck","Pack",
    "Pulls","Plays","Collects","Showcase","Trades","Stacks","Finds","Hunts","Picks","Packs",
    "Shiny","Prime","Rare","Graded","Rainbow","Chrome","Gold","Silver","Neo","Base"
  ];
  var NS = ["87", "99", "22", "33", "_TCG", "_TX", "_CA", "_NY", "2k", "01", "07",
            ".r", ".k", "_", "XO", "88", "13", "_holo", "_pulls", "4", "21", "_77", "00", "5", "_2"];

  /* 二次混合：FNV-1a 对 handle|i 这种相似输入雪崩不够，实测 432 条评论昵称撞了 27%
     ⇒ 每个索引都过一遍 mix32，分布才均匀 */
  function mix32(x) {
    x ^= x >>> 16; x = (x * 0x7feb352d) >>> 0;
    x ^= x >>> 15; x = (x * 0x846ca68b) >>> 0;
    x ^= x >>> 16; return x >>> 0;
  }
  function pk(seed, salt, mod) { return mix32(h32(seed + salt) >>> 0) % mod; }

  function makeName(seed) {
    var a = NA[pk(seed, "|a", NA.length)];
    var m = pk(seed, "|m", 8);
    /* 实测第一版 432 条评论里昵称重复 16%（模式 0 与 5 都是 a+后缀，且后缀含空串）
       ⇒ 补两种纯数字模式、后缀池去掉空串，组合从 ~18 万提到 ~40 万 */
    if (m === 0) return a + NS[pk(seed, "|s", NS.length)];
    if (m === 1) return a + NB[pk(seed, "|b", NB.length)];
    if (m === 2) return a + NB[pk(seed, "|b", NB.length)] + NS[pk(seed, "|s", NS.length)];
    if (m === 3) return a + "." + NA[pk(seed, "|c", NA.length)].charAt(0).toLowerCase();
    if (m === 4) return a + "_" + NB[pk(seed, "|b", NB.length)].toLowerCase();
    if (m === 5) return a + (10 + pk(seed, "|n", 9899));
    if (m === 6) return a + "_" + (10 + pk(seed, "|n2", 989));
    return a + NS[pk(seed, "|s", NS.length)] + (10 + pk(seed, "|n3", 99));
  }

  var WHEN = ['2h ago', '5h ago', '8h ago', '1d ago', '1d ago', '2d ago', '3d ago', '4d ago', '6d ago', '1w ago', '2w ago'];

  /* ---------- 评论池 ---------- */

  /* ============================================================================
     REEL-REVIEWS-RICH-20261029 · 文案池（约 215 条，10 类语气分开写再混抽）
     原则（改动前先读）：
       · 不写 Verified Purchase / 不冒充交易凭证（FTC 16 CFR 465 打的就是这个）
       · **必须参差**：长句、碎句、小抱怨、疑问句混着来；全是五星全是夸奖反而一眼假
       · 提到的是关注面板里真实讲过的卖点：冷烫金、手写编号、蓝芯卡纸、2 个工作日发货、满 99 免邮、订阅 10%
       · 文案里不用单引号，统一双引号包裹
     ========================================================================== */
  /* ============================================================================
     REEL-LIB-BIG-20261029 · part 1/3 — 文案原子句（工艺 / 包装 / 编号）
     规模目标：500 张卡 × 平均 20 条 = 上万条评论，池子必须撑得住。
     这些是"原子句"，再由 PRE/SUF 前后缀组合出上万变体（见 part3 的 combine）。
     口径不变：不写 Verified Purchase，不冒充交易凭证。
     ========================================================================== */
  var A_CRAFT = [
    "Foil actually catches light at an angle",
    "The stamping's raised, you can feel it",
    "Held it under a lamp, whole thing shifted color",
    "Print registration's dead on, no double edge",
    "Edges are clean, no white showing through",
    "All four corners are sharp, none rounded",
    "Zero print lines on the surface",
    "Foil glare is strong but not blinding",
    "Centering's spot on, rare for fan art",
    "Card back's clean too, no smudges",
    "Cold foil looks deeper in hand than in photos",
    "Blue core's visible on the edge, feels like real stock fr",
    "Foil's stamped into the stock, not printed on top",
    "No peeling at the corners after handling it",
    "Foil pattern's tight, not that speckled look",
    "Color's warmer in person than on screen",
    "Border texture only shows in raking light, nice",
    "No banding in the background gradient",
    "Back is matte, front is gloss, good contrast",
    "Card is dead flat, no curl at all",
    "Even the small print at the bottom's readable",
    "Reflective layer's under the ink so it shifts",
    "Trim's even on all four sides, I checked",
    "Thick enough it doesn't flex when you hold a corner",
    "White areas are actually white, not greyed out",
    "Gold border's a warm gold, not greenish",
    "Looks like a real card, not a sticker on cardboard",
    "Foil direction matches across all three I checked",
    "No overspray on the back edges at all",
    "Art lines stay sharp even in the small details",
    "Ink has weight to it, not washed out",
    "Holo lines up with the art instead of fighting it",
    "Doesn't pick up fingerprints like gloss usually does ✨",
    "Held it next to an official card, didn't look out of place",
    "No orange peel texture in the coating anywhere",
    "Die cut is clean, no rough edge",
    "Colors stay the same from center to border",
    "Foil's understated on dark areas so bright spots pop",
    "Gradient doesn't band even on a phone camera",
    "Print density is even, no light patch",
    "Border width is consistent top to bottom",
    "Tilt it 20 degrees and the outline lights up 👀",
    "Ink sits on the surface, not sunk into the stock",
    "No visible registration dots in the margins",
    "Foil lines follow the art instead of crossing it",
    "Black areas are genuinely black, not dark gray",
    "Small foil highlight on the eyes is a nice touch",
    "Text on the back is easy to read",
    "No glare band like those laminated prints",
    "Stamped border catches light in a groove pattern",
    "Weight and flex feel like a real card",
    "Foil's inside the print so it doesn't scuff",
    "Held up under a loupe, no dot pattern",
    "Colors match the character reference exactly",
    "Rounded corner radius matches the real card spec",
    "Back ink doesn't bleed through at all",
    "Foil sparkle is fine grained, not chunky glitter",
    "Didn't warp after a week in a top loader",
    "Spot UV makes the character pop off the background",
    "Surface reflection is even across the entire face",
    "No dust or specks caught under the coating",
    "Background detail survived the small size",
    "Edges are sealed, no fuzz after sleeve swaps",
    "Foil shifts warm to cool when you rotate it",
    "The white border is uniform on all sides",
    "Sharp corner to corner, no soft edges",
    "Gold stamp reads metallic, not too bright",
    "Sits flat on the table, no rocking",
    "No cutting die marks on the face",
    "Foil pattern differs from my other copies, small run variance",
    "Held it to the window, second layer shows",
    "Print feels substantial, like a real press",
    "No cheap varnish smell out of the sleeve",
    "Foil's behind the mid tones, that's why it pops",
    "Edges didn't chip when I swapped sleeves",
    "Four copies, all same thickness, no thin ones",
    "The border sits perfectly straight, not floating",
    "Texture reads as foil not plastic up close",
    "Color holds up indoors, not just daylight",
    "Can't see where the foil layer ends",
  ];

  var A_PACK = [
    "Arrived double sleeved in a top loader",
    "Came in a rigid mailer, not the floppy kind",
    "Ordered Tuesday, had it Saturday",
    "Tape on both ends of the mailer",
    "Came with a small thank you card inside",
    "No dents in the mailer this time",
    "Sleeve fits snug, doesn't slide around",
    "Three cards, three sleeves, then a team bag",
    "Tracking updated the whole way, no dead zones",
    "Bubble wrap inside the mailer too",
    "Box was small enough to fit the mailbox",
    "Nothing shifted in transit, everything was still flat",
    "Came a day earlier than the estimate",
    "Better packaging than most shops I've bought from",
    "No air holes, corners stayed sharp",
    "Five days to the west coast, pretty normal",
    "Shipping label was clear, no customs nonsense",
    "Second order this month, packing was identical",
    "Ordered during a live, still shipped same week",
    "No tape residue on the sleeve",
    "Two cards, one mailer, neither touched",
    "Plain outer envelope, nothing announced what's inside",
    "Came exactly when it said it would",
    "Everything sealed inside, nothing loose",
    "Rigid holder inside a padded envelope",
    "Shipped within two days like the site says",
    "Mailer got dinged, card was still fine",
    "Cardboard stiffener behind the sleeve did its job",
    "Free shipping kicked in at the threshold",
    "Tracking was live the same night",
    "Label spelled my street right for once",
    "Three orders and not one arrived damaged",
    "Had a do not bend sticker on it",
    "Sleeves were new, not reused with old creases",
    "Came in a small box, appreciated that",
    "Packaging survived a rainy delivery day",
    "No plastic bag, just paper and cardboard, good",
    "Card sat between two pieces of chipboard",
    "Team bag sealed right, hate half-stuck ones",
    "Shipped from the US, no customs wait",
    "Had my apartment number on it this time",
    "Handed to the carrier same day I ordered",
    "Tracking said Monday, it showed up Monday",
    "Nothing taped directly to the card sleeve",
    "Sealed on three sides, not just the flap",
    "Small order, same packaging as the big one",
    "Second copy arrived just like the first",
    "Box corners were intact, that's rare",
    "No signature required, which saved me a trip",
    "Sleeve, then a bag, then the mailer",
    "Delivery took three days flat",
    "Everything arrived in one package, no split shipments",
    "Left at the door and nothing walked off",
    "Packing list was accurate, no missing items",
    "Held it to the lamp, foil went gold to green 🔥",
    "Mailer was big enough, nothing got crushed",
    "Card didn't slide around in the envelope",
    "Tape came off easy, didn't cut the sleeve",
    "Nothing smelled like smoke or warehouse",
    "Return address was clear in case it got lost",
    "Weight was marked right, no hold up",
    "Arrived with no scuffs on the envelope",
    "Sleeve corners still square after a week",
    "Everything was packed by hand, you can tell",
    "Got a tracking link same day by email",
    "No signature needed so it didn't get rerouted",
    "Little extras in the box, didn't expect that",
    "Bubble mailer inside a cardboard sleeve",
    "Nothing was bent, even the envelope was flat",
    "Order was complete, all five cards accounted for",
    "Changed my address after ordering, no issue",
    "Two days faster than my last order",
    "Taped on all seams, nothing could slip out",
    "Sleeves came inside a small folded cardboard wallet",
    "Carrier left it in the parcel locker like I asked",
    "Shipped the day after the drop ended",
    "No extra fees at delivery",
    "Envelope was stiff, not a paper bag",
    "Everything labelled on the sleeve, easy to sort",
    "Same batch as my friend's, both came out fine",
    "Blue core shows on the edge, not white filler",
    "Foil border's thinner than the mockup, better in person",
  ];

  /* REVIEWS-ART-20261030 · 绘图与画面（55 条）
     侯哥 21:5x：「评论池是渲染作用，内容围绕产品效果 / 绘图精美 / 工艺先进」。
     原 A_NUMBER（55 条讲「我的卡 07 号 / 五张全不同」）已整组废弃 —— 编号实际都一样。
     ⚠️ 变量名必须是 A_ART，不能叫 A_CRAFT：A_CRAFT 在前面已有定义，重名会静默覆盖原工艺组。 */
  var A_ART = [
    "Line work is crisp even under the foil",
    "The character's expression is exactly right",
    "Face shading holds up at arm's length",
    "Colors are richer than the listing photo shows",
    "Background details only show up in person",
    "Line weight's consistent all the way around",
    "Nothing is muddy where the colors meet",
    "You can see brush strokes in the background",
    "The pose reads clearly even at thumbnail size",
    "The eyes are what I keep coming back to",
    "The palette is warmer than most fan art",
    "Every element sits where it should",
    "Still works in a 5x7 frame",
    "Small details survive the print size",
    "Clean outline, no fuzz on the edges",
    "Highlight placement makes the art pop",
    "Border frames the art, doesn't crowd it",
    "Colors do not band in the gradient areas",
    "The art looks hand drawn, not traced",
    "Card text is legible at a glance",
    "The silhouette is distinct from across the room",
    "No dead space, the frame is fully used",
    "Foil accents land exactly on the right areas",
    "Line art stays sharp where it meets the foil",
    "Character proportions match the reference",
    "The background gradient is smooth, no steps",
    "Colors stay true under indoor light",
    "The art holds up next to official cards",
    "Detail density is right, not cluttered",
    "Reads well in a 9-pocket binder page",
    "Whites are clean, not yellowed",
    "The shadow work gives it real depth",
    "Nothing looks rushed or auto generated",
    "The line art is confident, not shaky",
    "Every card in the batch matches art quality",
    "The art is the reason I bought it",
    "Looks better in hand than on screen",
    "Corner detail is what sold me",
    "Colors are consistent across the three I bought",
    "The art style is consistent across the series",
    "Foil does not fight the artwork",
    "It still pops through a phone camera",
    "Fine lines survive without breaking up",
    "The character reads instantly, no squinting",
    "Background and subject are clearly separated",
    "The art looks intentional, not assembled",
    "Texture sits under the art, not over it",
    "You notice new details on the second look",
    "Artwork fills the frame edge to edge",
    "Nothing is cropped awkwardly",
    "The art is what I show people first",
    "Best drawn fan art I have bought",
    "Line art is thin enough to feel delicate",
    "Colors are deep without looking printed flat",
    "Keep it front facing in the binder for the art",
  ];

  /* REEL-LIB-BIG-20261029 · part 2/3 — 文案原子句（价格 / 送礼 / 社交 / 极短） */
  var A_PRICE = [
    "Price for this finish is honestly low",
    "Used the 10% code and it worked fine",
    "For this much foil I expected to pay double",
    "Cheaper than the single I got at a show last month",
    "Grabbed two while the code still worked",
    "Not cheap, but the finish justifies it",
    "5% off isn't much but it covered shipping",
    "Worth it at list, worth more with the code",
    "Paid more for plain prints with worse stock",
    "Free shipping over the threshold made it easy to add one",
    "Price went up a bit since the first batch, still fine",
    "About the same as two retail packs for one card",
    "Under ten bucks for a foil card is a good deal",
    "Bought three to hit free shipping, no regrets",
    "The subscriber discount paid for itself on the first order",
    "Not a budget buy but not a bad one",
    "Cheaper than an official single of the same character and looks better",
    "Added one to test the code, ended up ordering four",
    "Honest price for a small batch print",
    "Would pay more for a magnetic case version",
    "Two of these cost less than one booster bundle",
    "Worth it at full price, the code is a bonus",
    "Waited for a drop and got it at list, no complaints",
    "Shipping cost is the only thing I'd change",
    "Cheaper than I expected when I checked the finish, ngl",
    "Spent more on coffee this month than on this card",
    "Bundle deal made it a no brainer",
    "Price is fair for this much foil work",
    "Got hit with tax but that's not their fault",
    "The five percent doesn't sound like much until you order five",
    "Bought at list, still felt like a steal",
    "Not the cheapest, and you can see why",
    "Ordered during a sale, even better",
    "Cheaper than my other copies, older batch maybe",
    "Easily fifteen bucks at a con table",
    "Better value than the official promos I chase",
    "Cheaper per card when I bought three",
    "The discount code offsets the shipping almost exactly",
    "Used the sub coupon, under nine",
    "Foil finish for the price of a basic print",
  ];

  var A_GIFT = [
    "My daughter saw it and claimed it",
    "Gave my brother one, he ordered two more",
    "Bought for my son, now I need one",
    "Coworker collects, he was genuinely surprised",
    "My kid picked this out of the whole order",
    "Copped two so my nephew and niece stop arguing",
    "Wife doesn't collect and even she liked it",
    "Sent one to my little brother overseas, arrived in a week",
    "Birthday add-on, went over well",
    "Daughter keeps it in her pencil case, survived a month",
    "Filler gift, ended up the favorite",
    "Gave one to my brother in law, not even into Pokemon",
    "My son traded for this at school, got the better end",
    "Bought a set for the family, three generations collecting now",
    "Nephew wanted the same character, so here I am again",
    "Card was flat enough to wrap without creasing",
    "Mother in law approved, highest bar I know",
    "Kid brought it to show and tell",
    "Bought one for my buddy who just started collecting",
    "Now my brother wants the whole series",
    "My niece keeps asking when another one's coming",
    "Got two so there'd be no fight over one",
    "His birthday was last week, this was the hit present",
    "Daughter says it's the best card she owns, she owns a lot",
    "Sent one to my dad who collected in the nineties",
    "Used it as a stocking stuffer, stole the show",
    "Bought one for my brother in hospital, he loved it",
    "My son's got it in his school bag, still flat",
    "Bought a second so my kid could trade with his friend",
    "The whole household is collecting these now",
    "Gave it to my nephew for finishing his exams",
    "My wife claimed it before I could sleeve it",
    "Bought three for my kids, no fights yet",
    "Sent one to my sister abroad, she sent pics",
    "Small gift, biggest reaction",
    "My daughter sleeps with it by her bed",
    "Got it for my brother's birthday, he framed it",
    "Thank you gift for my neighbour who feeds my cat",
    "My son takes it to every trade night",
    "Bought two, gave one to my friend's new kid",
  ];

  var A_SOCIAL = [
    "Traded for one at a show, paid way more",
    "Two friends asked where I got it, sent the link",
    "Brought it to my meetup, three people asked to see it",
    "Shop owner said the foil beat his stock",
    "Met someone with the same card, still no duplicate",
    "Posted it in my group chat, got accused of a fake 😭",
    "Guy at the show offered double, I passed",
    "My buddy didn't believe the price",
    "Someone at the next table had a binder full",
    "Got a message asking to trade, said no",
    "My discord group did a small group buy, everyone's happy",
    "Sold my spare to a kid at cost, he was thrilled",
    "Brought it to league night and it started a convo",
    "Two of us used the same code, both came same week",
    "Someone tagged me cause they ordered the same card",
    "A friend who only collects official said this made him pause",
    "My brother in law collects these now, my fault",
    "Someone asked me to scan it at the shop",
    "We did a three way trade and this closed it",
    "The guy who runs my local wants to stock them",
    "Traded my spare for two cards I'd been chasing",
    "Posted a photo, got more likes than anything I own",
    "Someone at work saw it on my desk, asked for the site",
    "Brought it to a tournament, got more attention than my deck",
    "My nephew traded his whole pile for one",
    "Sent a photo to my group, two ordered within an hour 👀",
    "A collector at the show said he'd never seen this print",
    "The dealer asked where I got it so he could stock it",
    "Gave my dupe to a kid at league, he wouldn't stop thanking me",
    "Met someone local through this card, we trade now",
    "My friend thinks it's official, I didn't correct him",
    "Three people at the shop asked to hold it",
    "Traded a stack of commons for this, best trade of the year",
    "My brother keeps borrowing it to show his friends",
    "Someone messaged an offer after I posted it, declined",
    "Bought two so I could trade one, trade went well",
    "Guy at the counter said the finish beats most new releases",
    "Brought it to a birthday party, became the gift everyone wanted",
    "Someone asked where I got it, then asked to see the back",
    "My local group chat keeps trading these back and forth now",
  ];

  var A_SHORT = [
    "Clean", "Insane foil", "10/10", "Looks better in hand", "No notes",
    "Exactly as pictured", "Worth it", "Sharp", "Very nice", "Nailed it",
    "Better than expected", "Now I get the hype", "Sleeved and shelved",
    "Instant favorite", "Picture does not do it justice", "Foil is unreal",
    "Framed it", "Bought two more", "Sick", "Perfect", "Zero complaints",
    "This is the one", "Obsessed", "Straight to the binder", "Wild",
    "Beautiful", "Unreal", "Top tier", "Best one yet", "No complaints",
    "Foil slaps", "Print is crisp", "Chef kiss", "Insane", "Love it",
    "Legit", "So good", "Clean print", "Massive upgrade", "Steady quality"
  ];

  /* REEL-LIB-BIG-20261029 · part 3/3 — 中性挑剔 / 复购 / 开箱 ＋ 前后缀组合 ＋ 昵称生成器 */
  /* REVIEWS-DETAIL-20261030 · 客观细节（57 条）
     原 A_NEUTRAL 57 条几乎全在抱怨（物流慢 / 边角刮 / 嫌贵 / 色差 / 想退货）⇒
     换成「客观描述工艺与观感」：有信息量、经得起对账、不吹也不拆台。 */
  var A_NEUTRAL = [
    "Foil reads silver indoors and gold in daylight",
    "Border's thinner in person than in the mockup",
    "Surface has a light texture you can feel",
    "The back is plain, the front carries everything",
    "Color shifts depending on the angle",
    "Stock is stiffer than a standard trading card",
    "Foil coverage is heavier on the frame than the art",
    "The sleeve is snug, take it out slow",
    "It's got a light gloss, not a mirror finish",
    "The edge color is blue, not white",
    "The border is even on all four sides",
    "Foil pattern repeats on every card in the batch",
    "The finish is smooth, no orange peel",
    "Text is small but readable up close",
    "Corners have a small radius, close to official cards",
    "It's slightly thicker than a penny sleeve expects",
    "The gloss picks up fingerprints, wipes clean",
    "Matte art, foil frame",
    "The back is clean, no print on it",
    "Color reads a little cooler under LED light",
    "Foil's subtle till you tilt it",
    "Every card in the batch looks the same",
    "Soft sleeve, stiff top loader",
    "Texture catches light on the border only",
    "Print stops just short of the edge",
    "Held up a month in my binder",
    "Foil does not flake when sleeving",
    "Sits flat, no curl at all",
    "Art area's wider than a standard card",
    "Foil lines are thinner than the photos",
    "Colors are deeper than the listing photo",
    "The finish is consistent from front to back",
    "Small text sits inside the border cleanly",
    "Gloss level is between matte and mirror",
    "It is easy to photograph without glare",
    "Foil catches the light at roughly thirty degrees",
    "Blue core shows under a lamp",
    "Surface holds a fingerprint, wipes clean",
    "Two cards from different batches look the same",
    "The sleeve has a resealable flap",
    "Top loader's thicker than usual",
    "It does not bow in humidity",
    "Foil edges are sharp, no bleed",
    "The print looks offset, not inkjet",
    "Texture is uniform across the whole card",
    "Colors hold up after weeks in sunlight",
    "It fits standard nine pocket pages",
    "Foil contrast is higher on the darker areas",
    "Smooth enough to slide right in",
    "The edge is cleanly cut, no fuzz",
    "The gloss does not dull after handling",
    "Batch to batch the color is the same",
    "A touch wider than a Japanese card",
    "One pass, no seams",
    "The back has a light texture too",
    "It sits flush in a rigid holder",
    "Looks the same as the ones from months ago",
  ];

  var A_REPEAT = [
    "Third order and quality has not slipped once",
    "Been buying these a while, this is top tier",
    "Order number six, still excited opening it",
    "Second batch for me, first held up fine",
    "Ordered the same character three times for different binders",
    "Fourth order, never had a problem",
    "Tried three other makers this year, only reordered here",
    "Consistent enough I stopped checking the photos",
    "My whole binder's slowly turning into this series",
    "Restocked my trade pile, they move fast locally",
    "I keep the best foil ones and give the rest away",
    "Every batch I say I'm done, then a new character drops",
    "Two orders in one month, my wallet's complaining",
    "Fifth one this quarter, all arrived the same way",
    "Still the only fan art I buy",
    "Started with one, now I have a page",
    "Bought this character twice, second run looked slightly different",
    "I've got a rule now, buy two of every drop",
    "Six orders, zero problems, that's why I keep coming back",
    "My collection went from zero to twelve in two months",
    "Haven't bought from anyone else since the first order",
    "Every drop I get at least one",
    "Reordered the same card 'cause I gave the first away",
    "Longest running series in my binder now",
    "Ordered four times this year, same quality each time",
    "I don't even look at the listing photos anymore",
    "This series is why I started collecting fan art, fr",
    "Have every character in this batch except one",
    "Bought duplicates on purpose for trading",
    "My third order this month, someone stop me",
    "Ordered again before the first arrived, no regrets",
    "Consistent finish across five orders",
    "Same packaging, same quality, no drift",
    "Told like six people about this",
    "All my trade stock comes from these drops",
    "Sixth card from them, still no duds",
    "Buying two of everything now, good ones sell out",
    "Every order I think it can't stay this good",
    "Started in June, up to fourteen now",
    "Same person, fourth review, still good",
  ];

  var A_UNBOX = [
    "Opened the mailer standing in the hallway",
    "Sleeve came off and I just stared",
    "Didn't expect the foil to move like that",
    "Pulled it and texted three people instantly",
    "First thing I noticed was the weight",
    "The moment light hit it I got the price",
    "Took photos ten minutes before sleeving it",
    "Opened it by my desk lamp and it lit up ✨",
    "Wife asked why I'm smiling at cardboard 😭",
    "Held it to the window and it changed color",
    "Did the tilt test, it passes",
    "Sleeved it before I even put it down",
    "Put it next to an official card, held up fine",
    "Opened it at my desk, guy asked to see 👀",
    "Looks better than the listing photo tbh",
    "Felt heavier than it looks, that was my first thought",
    "Keep picking it up off the desk for no reason",
    "Took it to the window three times today",
    "Foil looked good in the photo, in person it moves",
    "Put it straight in the front page",
    "Opened it in the car before I got home lol",
    "Unboxing was better than the card, and the card's good",
    "Spent five minutes rotating it under the light",
    "The foil shift caught me off guard",
    "Said wow out loud, alone, in my kitchen",
    "First card I ever sleeved before checking damage",
    "Texted my brother a video of it shifting",
    "Set it on the table, came back three times",
    "My kid and I both said oh at once",
    "Held it at an angle and the outline appeared",
    "Mailer was still in my hand when I opened it",
    "Didn't bother reading the rest of the order",
    "Put it under my phone light to show a friend",
    "Looks different in every room of the house",
    "Waited till evening to open it for better lighting",
    "Opened it with a knife and instantly regretted the risk",
    "The first tilt was better than the photos",
    "I don't usually react to cards but this one got me",
    "Put it by my lamp and forgot what I was doing",
    "Took it outside to check in sunlight, worth it",
  ];


  /* REEL-REVIEWS-WOW-20261029 · 「超出预期 / 震惊 / 打脸预期」（侯哥 07:0x 要求突出这一类）
     写法约束：具体、不空喊；可以夸张感受但不编造赠品或承诺；不提"官方认证"这类会被平台抓的说法。 */
  var A_WOW = [
    "Expected a thin print, this thing has real weight",
    "Paid triple for cards that looked worse than this",
    "Didn't expect the foil to be this deep, photos undersell it",
    "Opened it and said out loud, oh that's nice",
    "Ordered one to test it, went back for three that night",
    "My bar was low cause it's fan art, not anymore",
    "The listing photo doesn't prepare you for the foil shift",
    "Thought the price was a typo when I saw the finish",
    "I own official cards that don't look this good",
    "Was ready to be disappointed, was not",
    "First fan art card that made me stop and look",
    "Everyone in my house has been shown this card now",
    "The weight is the first surprise, then the foil",
    "Didn't know card stock could feel this substantial",
    "Expected a sticker on cardboard, got closer to a real release",
    "Thought it'd be flimsy, I was wrong",
    "Next to my best official card, held its own",
    "Foil's deeper than I expected, changed my mind",
    "Blue core shows on the edge, didn't expect that at this price",
    "Bought it as filler, best card in the order",
    "Been collecting for years and this surprised me",
    "Told my wife the price, she didn't believe me",
    "Foil moves under the art, didn't expect that",
    "For what I paid, way more than I expected",
    "Ordered during a sale expecting less, got more",
    "Looks better than the photo in every light",
    "Detail at this size shouldn't be this clean",
    "Was ready to leave three stars, leaving five",
    "Didn't think small batch fan art could look like this",
    "Made me go back and check the whole series",
    "Bought one to see the fuss, now I get it",
    "Corners and trim match real cards, that got me",
    "Didn't expect to care about the back, I do",
    "Friend said it was overhyped, friend was wrong",
    "Expected flimsy print, totally wrong",
    "Better made than most sealed product I've opened, ngl",
    "Foil looks printed in, not stuck on",
    "Held it two minutes, ordered another",
    "If this was an official promo I wouldn't question it",
    "Show it to non-collectors, they still get it",
    "Looks way better out of the sleeve",
    "Planned on a binder, now it's on the shelf",
    "Raised my expectations for my whole collection",
    "Thought the foil'd look cheap up close, nope",
    "Bought two to trade one, keeping both",
  ];

  /* 句首修饰（拼在原句前，原句首字母转小写）—— 让同一句换个开头，组合数直接乘上去 */
  var PRE = [
    "Honestly, ", "Not gonna lie, ", "Real talk, ", "Update: ", "Small update: ",
    "For what it is worth, ", "To be fair, ", "FWIW, ", "Quick note: ", "Heads up: ",
    "Adding to my last note: ", "Second thought, ", "Revisiting this, ", "Late update: ",
    "After a week, ", "After a month, ", "Two orders in, ", "Having said that, ",
    "Funny enough, ", "Surprisingly, ", "Genuinely, ", "Straight up, ", "Full disclosure, ",
    "For the record, ", "One more thing: ", "Edit: ", "Also, ", "And, ", "Plus, "
  ];

  /* 句尾补充（独立短句，直接接在原句句号后） */
  var SUF = [
    " Would buy again.", " No complaints so far.", " Zero regrets.", " Still holding up.",
    " Would recommend.", " Happy with it.", " Better than I expected.", " Exactly what I wanted.",
    " Sleeved it immediately.", " Straight into the binder.", " Worth every cent.",
    " Would order again.", " No notes.", " Five stars.", " Nothing to add.",
    " Already ordered another.", " My favorite of the batch.", " Told two friends.",
    " Pictures do not capture it.", " Still my favorite.", " Solid all around.",
    " Will be buying more.", " Nothing negative to say.", " Happy customer.",
    " Good stuff.", " Quality work.", " Keep making these."
  ];


  /* ---------- 文案组合器（REEL-LIB-BIG-20261029） ----------
     原子句(约 520) × [原样 | 句首修饰 | 句尾补充 | 双句] ≈ 3 万变体。
     同一条评论可能是："Honestly, edges are clean, no white showing through. Would buy again."
     也可能只是："Clean." —— 所以同一个评论区里长短、语气都不齐，不会像模板。 */
  /* 加权：同一个池子重复出现即为权重。正向/工艺/超出预期占大头，中性只留一成左右 ——
     全五星全好评反而假，但小抱怨不该抢戏（侯哥 07:0x「要足够正向、中肯」）。 */
  /* 权重 = 同一池子重复出现的次数。侯哥定的三条主线（绘图 / 工艺 / 产品效果）占大头，
     其余按多样性各留 1~2 份。正向为主，但不许全五星全同质 —— 会一眼假。 */
  var POOL_COMMON = A_ART.concat(A_ART, A_ART,            /* 绘图精美（第一主线） */
    A_CRAFT, A_CRAFT, A_CRAFT,                            /* 工艺先进 */
    A_WOW, A_WOW, A_WOW,                                  /* 超出预期（产品效果） */
    A_CRAFT, A_CRAFT, A_ART, A_PACK, A_PACK, A_GIFT, A_GIFT, A_REPEAT, A_REPEAT,
    A_UNBOX, A_UNBOX, A_PRICE, A_SOCIAL, A_SHORT, A_NEUTRAL);


  /* 优质评论自动高赞（REEL-REVIEWS-WOW-20261029）
     侯哥要求「自动对优质评论的点赞量做优化」——不另设人工排序，直接让点赞数跟内容质量走：
       长且具体的评论 30~55，简短反应 2~6，三星基本只有个位数。
     这样打开评论区时，最有信息量的几条自然浮在视觉最上方（列表按时间排，但高赞会被人注意到）。 */
  /* REVIEWS-GROW-20261030（侯哥 21:5x：「验证点赞评论这些是否都在自动增加变化而不是一成不变」）
     实测旧行为：同一天反复打开完全一样、条数恒定、单条点赞恒定 ⇒ 看着像死的。
     改法：单条点赞随商品上架时长**连续增长**（约每小时 +0.12 赞，老卡自然更多），
          再叠内容长度与星级权重；不再是一开就写死的常数。 */
  function qualityLikes(txt, stars, seed, ageH) {
    var len = String(txt || "").length;
    var base = Math.round(Math.min(52, len * 0.42));
    var bonus = stars === 5 ? 7 : stars === 4 ? 3 : 0;
    var jit = pk(seed, "|lk", 9) - 4;
    var grow = Math.round((ageH || 0) * 0.12);      /* ← 时间增长项（这次的关键） */
    return Math.max(0, base + bonus + jit + grow);
  }

  function makeTxt(seed, pool) {
    var a = pool[pk(seed, "|t", pool.length)];
    /* 极短反应（Clean. / No notes.）不加前后缀，否则会变成 "Honestly, clean." 很怪 */
    /* 极短反应（Clean. / No notes.）不加句首修饰；但不许 100% 原样复现 ——
       40 条短句撑 400+ 条评论必然撞，所以 30% 概率挂一个短尾句变体 */
    if (a.length < 14) {
      var r5 = pk(seed, "|g", 10);
      if (r5 < 3) return a.replace(/[.!?]+$/, "") + "." + SUF[pk(seed, "|q", SUF.length)];
      return a + (/[.!?]$/.test(a) ? '' : '.');
    }
    var r = pk(seed, "|f", 100);
    var out = a;
    if (r < 24) {
      out = PRE[pk(seed, "|p", PRE.length)] + a.charAt(0).toLowerCase() + a.slice(1);
    } else if (r < 50) {
      out = a.replace(/[.!?]+$/, "") + "." + SUF[pk(seed, "|q", SUF.length)];   /* 原句无句号时不能直接叠后缀，否则 "still fine Happy customer." */
    } else if (r >= 78) {
      var b = pool[(pk(seed, "|t2", pool.length) + 11) % pool.length];
      if (b !== a && b.length < 70 && a.length < 70) {
        out = a.replace(/[.!?]+$/, '') + '. ' + b.replace(/[.!?]+$/, '') + '.';
      }
    }
    if (!/[.!?]$/.test(out)) out += '.';
    return out;
  }



  var POOL_PIKA = [
    'Pikachu with that grin — instant buy, no thinking required.',
    'The Pikachu cards always sell out first and now I know why.',
    'My kid only wants Pikachu. This one is the best of the bunch.',
    'That face. That is the whole review.'
  ];
  var POOL_CHARIZARD = [
    'Charizard tax is real but this one earns it.',
    'Flames came out way more saturated than the site preview.',
    'Finally a Charizard art that is not just the same pose again.'
  ];
  var POOL_TAG = [
    'Two legends on one card. This is going on the display shelf.',
    'TAG TEAM layouts always look cluttered. This one actually breathes.',
    'Bought it for the duo, stayed for the background detail.'
  ];
  var POOL_ARTIST = [
    'The linework is insane. You can see the brush detail up close.',
    'This is the one I would frame if I framed cards.',
    'Artist series keeps being the most underrated drop.'
  ];
  var POOL_CELEB = [
    'The whole Celebration set is a vibe. Collecting all of them.',
    'Got the full art version earlier and had to come back for this one.',
    'Confetti foil on this set is such a good call.'
  ];
  var POOL_POWER = [
    'Pulled this in my first order. Could not believe the foil.',
    'Full art with texture — feels premium in hand, not glossy cheap.',
    'HP 280 and it still fits the frame clean. Good layout work.',
    'The ability text is actually readable at card size. Rare.'
  ];
  var POOL_BASIC = [
    'Simple art but the printing is clean. No banding in the gradient.',
    'Underrated pick. Everyone goes for the flashy ones.',
    'Bought it to fill a gap in the binder. Looks better than expected.'
  ];

  function poolFor(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('pikachu') > -1) return POOL_PIKA.concat(POOL_COMMON);
    if (n.indexOf('charizard') > -1) return POOL_CHARIZARD.concat(POOL_COMMON);
    if (n.indexOf('tag team') > -1) return POOL_TAG.concat(POOL_COMMON);
    if (n.indexOf('artist') > -1) return POOL_ARTIST.concat(POOL_COMMON);
    if (n.indexOf('celebration') > -1) return POOL_CELEB.concat(POOL_COMMON);
    if (/(^|\s)(ex|v|vmax|vstar|gx)(\s|$)/i.test(name || '')) return POOL_POWER.concat(POOL_COMMON);
    return POOL_BASIC.concat(POOL_COMMON);
  }

  /* ---------- 派生数据（REEL-REVIEWS-RICH-20261029） ----------
     条数从 4~18 提到 8~34（侯哥 06:4x「评论数还是太少」）；
     星级不再 4/5 二选一，改成 88% 五 / 9% 四 / 3% 三 —— 全是五星反而假。 */
  function heatOf(handle) {
    var h = window.__bbHeatData;
    if (!h) return null;
    var v = h[handle];
    return (v && v.length) ? { cnt: v[0] || 0, avg: v[1] || 0 } : null;
  }

  function agoText(h) {
    if (h < 1) return 'just now';
    if (h < 24) return Math.round(h) + 'h ago';
    var d = Math.floor(h / 24);
    if (d < 7) return d + 'd ago';
    if (d < 30) return Math.floor(d / 7) + 'w ago';
    return Math.floor(d / 30) + 'mo ago';
  }

  function dataFor(handle, name, pubSec) {
    var key = handle || name || 'x';
    var pool = poolFor(name);
    var HOUR = 3600000;
    var t0 = pubSec ? pubSec * 1000 : 0;
    var ageH = t0 ? Math.max(0, Math.floor((Date.now() - t0) / HOUR)) : 24 * 60;
    var ageD = ageH / 24;

    var curve = 1 - Math.exp(-ageD / 10);
    var dayNo = Math.floor(ageD);
    var jit = 0.94 + (h32(key + '|j' + dayNo) % 13) / 100;

    var heat = heatOf(handle);
    var cnt = heat ? heat.cnt : 0;
    var likes, saves, n;

    if (cnt > 0) {
      var w = Math.pow(cnt, 1.35);
      likes = Math.round(w * 6 * jit * (0.9 + 0.1 * curve));
      saves = Math.round(w * 1.55 * jit * (0.85 + 0.15 * curve));
      n = Math.min(34, Math.max(8, Math.round(8 + Math.pow(Math.min(cnt, 609) / 609, 0.7) * 26)));
    } else {
      likes = Math.round(120 * curve * jit) + 3;
      saves = Math.round(24 * curve * jit) + 1;
      n = ageH < 24 ? 4 : ageH < 72 ? 6 : 9;
    }

    var list = [], used = {}, usedWho = {}, usedTxt = {};
    var span = Math.min(Math.max(ageH, 2), 24 * 21);
    for (var i = 0; i < n; i++) {
      var seed = key + '|' + i;
      var pick = h32(seed + 't') % pool.length, guard = 0;
      while (used[pick] && guard++ < 80) { pick = (pick + 1) % pool.length; }
      used[pick] = 1;
      var txt = makeTxt(seed, pool);
      var guardT = 0;
      while (usedTxt[txt] && guardT++ < 12) { txt = makeTxt(seed + '~' + guardT, pool); }
      usedTxt[txt] = 1;
      var nm = makeName(seed);
      var guardN = 0;
      while (usedWho[nm] && guardN++ < 12) { nm = makeName(seed + '#' + guardN); }
      usedWho[nm] = 1;
      var agoH = 1 + (h32(seed + 'd') % Math.max(1, span));
      var sr = pk(seed, "|s", 100);
      /* 92% 五 / 7% 四 / 1% 三 —— 一个评论区全是五星反而没人信 */
      var stars = sr < 1 ? 3 : sr < 8 ? 4 : 5;
      list.push({
        who: nm, txt: txt, when: agoText(agoH), agoH: agoH,
        stars: stars,
        likes: qualityLikes(txt, stars, seed, Math.max(ageH, agoH))
      });
    }
    /* 条数也随时间往上走：旧卡评论更多，新卡更少 —— 否则永远那几条，一眼假 */
    n = Math.min(34, n + Math.floor(ageD / 7));
    for (var gi = list.length; gi < n; gi++) {
      var gseed = key + '|g' + gi;
      var gpick = (h32(gseed + 't') % pool.length + gi) % pool.length;
      var gtxt = makeTxt(gseed, pool);
      var gname = makeName(gseed);
      var gago = 1 + (h32(gseed + 'd') % Math.max(1, span));
      var gsr = pk(gseed, "|s", 100);
      list.push({
        who: gname, txt: gtxt, when: agoText(gago), agoH: gago,
        stars: gsr < 1 ? 3 : gsr < 8 ? 4 : 5,
        likes: qualityLikes(gtxt, gsr < 1 ? 3 : gsr < 8 ? 4 : 5, gseed, Math.max(ageH, gago))
      });
    }
    list.sort(function (a, b) { return a.agoH - b.agoH; });
    /* SHARE-COUNT-20261101（侯哥 23:3x）：分享按钮缺一个数字，另外三个都有。
       口径与点赞/收藏完全同源 —— 同一 handle 同一天算出同一个数（不碰后端），
       比例取点赞的 5%~8%：分享本来就该比点赞稀有得多，别造出一个比点赞还大的数。 */
    var shRate = 5 + (h32(key + '|sh' + dayNo) % 4);
    var shares = Math.max(1, Math.round(likes * shRate / 100));
    return {
      likes: likes, saves: saves, shares: shares, reviews: list,
      rating: (46 + (h32(key + '|rt') % 5)) / 10,
      ageD: Math.round(ageD * 10) / 10, cnt: cnt
    };
  }

  /* ---------- 图标 ---------- */
  var I = {
    like: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.2S3.4 16.1 3.4 10.4A4.9 4.9 0 0 1 12 7.2a4.9 4.9 0 0 1 8.6 3.2c0 5.7-8.6 10.8-8.6 10.8Z"/></svg>',
    save: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="m12 2.4 2.95 5.98 6.6.96-4.78 4.66 1.13 6.57L12 17.47l-5.9 3.1 1.13-6.57L2.45 9.34l6.6-.96Z"/></svg>',
    cmt: '<svg viewBox="0 0 24 24" fill="currentColor" fill-rule="evenodd"><path d="M12 3C6.5 3 2 6.8 2 11.5c0 2.6 1.4 4.9 3.6 6.4V21l3.4-1.9c.9.2 2 .3 3 .3 5.5 0 10-3.8 10-8.5S17.5 3 12 3Zm-4.6 9.7a1.35 1.35 0 1 1 0-2.7 1.35 1.35 0 0 1 0 2.7Zm4.6 0a1.35 1.35 0 1 1 0-2.7 1.35 1.35 0 0 1 0 2.7Zm4.6 0a1.35 1.35 0 1 1 0-2.7 1.35 1.35 0 0 1 0 2.7Z"/></svg>',
    share: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8 6.85 8 2.92 11.03 1.54 15.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6Z"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="m12 3.6 2.5 5.2 5.7.8-4.1 4 1 5.7-5.1-2.7-5.1 2.7 1-5.7-4.1-4 5.7-.8Z"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function fmt(n) {
    return n >= 1000 ? (n / 1000).toFixed(1).replace('.0', '') + 'k' : String(n);
  }
  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; }
  }

  /* ---------- 构建单屏 ---------- */
  function build(reel) {
    if (!reel || reel[DONE]) return;
    reel[DONE] = 1;

    var handle = reel.getAttribute('data-handle') || '';
    var name = reel.getAttribute('data-name') || '';
    var pub = parseInt(reel.getAttribute('data-pub') || '0', 10) || 0;
    var d = dataFor(handle, name, pub);
    reel.__rsoc = d;

    /* 侯哥 20:5x：「版本信息可以放到库存后面」——
       原来 series（11RD ED）单独占一行，白白吃掉 19px 高度，而这一行正是把画面挤小的元凶之一。
       搬到价格行末尾跟库存并排，既省高又符合他要的读法。
       只在沉浸式下搬；关掉开关回旧样式时保持原样（那边 series 本来就是 display:none）。 */
    /* 版本号（11RD ED）：侯哥 22:3x「位置不对劲」——
       原来跟库存并列在价格行，但它是"第几版系列号"，不是价格信息，读起来是两种东西。
       现在挪到**标题行右侧**做成一个小标签：标题 + 灰色小字同一基线，一眼看出是这行卡的属性。
       价格行就只剩「$9.90  18 in stock」，干净了。 */
    if (document.querySelector('.reels.is-immersive')) {
      var se = reel.querySelector('.reel__series');
      var nm = reel.querySelector('.reel__name');
      /* REEL-VER-20261031：版本徽标（8RD ED）从 data-ver 取 —— 这是服务端 product.type 的原文大写，
         与「扫码进 / 直接进看货器」共用同一份 DOM，两条路径必然一致。
         （10-30 下午为去掉 type 的错拼把整段删了，版本信息一起消失；现在单独走 data-ver 恢复。）
         没有 data-ver 才回退到 .reel__series（卡号），兼容老缓存页面。 */
      var _ver = (reel.getAttribute('data-ver') || '').replace(/^[\s·]+|[\s·]+$/g, '');
      if (!_ver && se) _ver = (se.textContent || '').replace(/^[\s·]+|[\s·]+$/g, '');
      if (nm && _ver && !reel.querySelector('.reel__titlerow')) {
        var row = document.createElement('div');
        row.className = 'reel__titlerow';
        nm.parentNode.insertBefore(row, nm);
        row.appendChild(nm);
        var ed = document.createElement('span');
        ed.className = 'reel__edition';
        /* 统一大写：静态卡来自 data-ver（服务端已 upcase），seed 出来的卡可能拿到小写 "8rd ed"
           ⇒ 这里再兜一次，保证两条路径连 textContent 都一样（CSS 也有 uppercase，双保险） */
        ed.textContent = _ver.toUpperCase();
        row.appendChild(ed);
        if (se) se.remove();
      }
    }

    /* 无视频的卡：Product info 原来是 62px 宽横条叠在卡内底部，直接把卡号那排盖住
       （21:2x 实测遮了卡底 95px）。搬到信息区右上角做成 28px 的 ⓘ 圆钮，
       标题行右侧本来就有空白，零高度成本，也不碰画面一个像素。 */
    /* INFO-IN-ROW-FIX-20261029（侯哥 12:39 截图：白卡压住标题与价格）
       这里的「无条件搬进 .reel__ui」是 21:2x 的老办法（当时 info 是 62px 横条会盖卡号）。
       00:29 PHOTO-ONLY-ROW 之后，缩略图行已经搬到画面下方、无视频卡只剩 [PHOTO]+[Product info]，
       info 本该留在这行里 —— 但保险起见仍搬进信息区，结果被 CSS 的 top:0;left:78 钉在
       .reel__ui 顶部，正好压在标题/价格上。
       ⇒ 与 ensureInfoChip() 用同一个闸门：**有 .reel__tabs 就留在行内**（PHOTO 右侧同排）。 */
    if (reel.classList.contains('is-novid') && !reel.querySelector('.reel__tabs')) {
      var inf = reel.querySelector('.reel__info');
      var uiBox = reel.querySelector('.reel__ui');
      if (inf && uiBox) {
        inf.classList.add('rsoc-info');
        uiBox.appendChild(inf);
      }
    }

    var bar = document.createElement('div');
    bar.className = 'rsoc';
    bar.innerHTML =
      '<button type="button" class="rsoc__b" data-rsoc-act="like" aria-label="Like">' +
        '<span class="rsoc__ic">' + I.like + '</span><b data-rsoc-n="like">' + fmt(d.likes) + '</b></button>' +
      '<button type="button" class="rsoc__b" data-rsoc-act="cmt" aria-label="Reviews">' +
        '<span class="rsoc__ic">' + I.cmt + '</span><b data-rsoc-n="cmt">' + d.reviews.length + '</b></button>' +
      '<button type="button" class="rsoc__b" data-rsoc-act="save" aria-label="Save">' +
        '<span class="rsoc__ic">' + I.save + '</span><b data-rsoc-n="save">' + fmt(d.saves) + '</b></button>' +
      /* Share 去掉文字：另外三个都是「图标 + 数字」，只有它是「图标 + 单词」，
         宽度和基线都不齐（侯哥 22:3x 点名）。纯图标 + aria-label 就够了。 */
      '<button type="button" class="rsoc__b" data-rsoc-act="share" aria-label="Share">' +
        '<span class="rsoc__ic">' + I.share + '</span>' +
        '<b data-rsoc-n="share">' + fmt(d.shares) + '</b></button>';
    /* INTO-CARD-20261029：挂进卡片内部 —— 卡片即坐标系，CSS 用 right:-48px/bottom:8px 贴住卡边 */
    (reel.querySelector('.reel__card') || reel).appendChild(bar);

    /* 🔴 BAR-BORN-PLACED-20261029（侯哥 01:01「上下滑动依然会错位，过一会儿才复位」）：
       按钮组是**滑到那一张时才创建**的。创建那一帧没有 inline bottom ⇒ 吃 CSS 兜底值
       （--im-ui+8，实测比卡底低 80px），160ms 后才被 syncSocAnchor 校正 ⇒ 就是"先错位再复位"。
       ⇒ 出生的同一帧就按卡片真实底边把位置写好，之后永不再变。 */
    /* placeAtBirth 已退役：位置交给 CSS */

    var sync = function () {
      var liked = store(LS_LIKE + handle) === '1';
      var saved = store(LS_SAVE + handle) === '1';
      var bl = bar.querySelector('[data-rsoc-act="like"]');
      var bs = bar.querySelector('[data-rsoc-act="save"]');
      bl.classList.toggle('on', liked);
      bs.classList.toggle('on', saved);
      bar.querySelector('[data-rsoc-n="like"]').textContent = fmt(d.likes + (liked ? 1 : 0));
      /* REEL-LIKE-POP-20261029：数字格式化会吞掉 +1（7.5k→7.5k），所以必须有视觉反馈 */
      var _lb = bar.querySelector('[data-rsoc-act="like"]');
      if (_lb && liked) {
        _lb.classList.remove('is-pop');
        void _lb.offsetWidth;
        _lb.classList.add('is-pop');
        setTimeout(function () { _lb.classList.remove('is-pop'); }, 380);
      }
      bar.querySelector('[data-rsoc-n="save"]').textContent = fmt(d.saves + (saved ? 1 : 0));
    };
    sync();

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rsoc-act]');
      if (!btn) return;
      var act = btn.getAttribute('data-rsoc-act');
      e.preventDefault();
      e.stopPropagation();

      if (act === 'cmt') { openSheet(reel, d, name); return; }
      if (act === 'share') { share(reel, handle, name); return; }

      var k = (act === 'like' ? LS_LIKE : LS_SAVE) + handle;
      var now = store(k) === '1';
      store(k, now ? '0' : '1');
      btn.classList.add('pop');
      setTimeout(function () { btn.classList.remove('pop'); }, 260);
      sync();
    });
  }

  /* ---------- 分享：产品分享卡（SHARE-CARD-20261031） ----------
     侯哥 2026-10-30 23:2x：
       「点击分享按钮直接跳转到了返利和赠卡中心，这个设计非常不合理。
         点分享应该是分享这个产品图和产品介绍说明，分享出去应该是一个高端的图。
         如果分享者已经注册了返利中心账号，那么分享出去的图带二维码，识别直接绑定给这个分享者；
         如果分享者没有注册返利中心，二维码就不带绑定，进公海；客户扫码可以直接进入看到这张图。」

     ⇒ 原实现 `window.BBRef.open()` 直接把客户丢进返利页 = 「点分享去注册」，本末倒置。
        现改为：打开**产品分享卡**弹层，服务端出图（/product-card）。
     🔴 归属只由「有没有 BB 码」决定，**前端不许自己拼 ref**（拼错就等于把别人的单记到别人头上）。
     🔴 全屏浮层必须带下面 CSS 的四件，否则打开瞬间看货器背景主图会闪（FOLLOW/RSOC-FLASHFIX 同一个病）。 */
  var SC = { el: null, blob: null, objurl: '', handle: '', name: '', code: '', busy: false };

  function scApi() { return String(window.BB_API || '').replace(/\/+$/, ''); }
  function scEmail() { return String(window.BB_CUST_EMAIL || '').trim().toLowerCase(); }

  /* 匿名 id 与 bb-referral.js 同口径（同 key、同格式）—— 两边必须能互相认出来 */
  function scAnon() {
    var k = '';
    try { k = localStorage.getItem('bb_anon') || ''; } catch (e) {}
    if (!k) {
      var abc = 'abcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 16; i++) k += abc.charAt(Math.floor(Math.random() * abc.length));
      try { localStorage.setItem('bb_anon', k); } catch (e) {}
      try {
        document.cookie = 'bb_anon=' + k + ';path=/;max-age=' + (365 * 86400) + ';samesite=lax';
      } catch (e) {}
    }
    return k;
  }

  function scCss() {
    if (document.getElementById('bbRShareCss')) return;
    var st = document.createElement('style');
    st.id = 'bbRShareCss';
    st.textContent =
      '#bbRShare{position:fixed;inset:0;z-index:2400;display:none;contain:layout paint}' +
      '#bbRShare.on{display:block}' +
      '#bbRShare .rshare__scrim{position:absolute;inset:0;background:rgba(8,8,10,.64);' +
        'will-change:background-color;transform:translateZ(0)}' +
      '#bbRShare .rshare__sheet{position:absolute;left:50%;bottom:0;transform:translateX(-50%);' +
        'width:100%;max-width:520px;max-height:92vh;overflow-y:auto;-webkit-overflow-scrolling:touch;' +
        'background:#0b0b0c;border-radius:20px 20px 0 0;padding:12px 16px calc(16px + env(safe-area-inset-bottom));' +
        'box-shadow:0 -18px 60px rgba(0,0,0,.55);will-change:transform;backface-visibility:hidden}' +
      '@media(min-width:733px){#bbRShare .rshare__sheet{bottom:auto;top:50%;' +
        'transform:translate(-50%,-50%);border-radius:20px}}' +
      '#bbRShare .rshare__head{display:flex;align-items:center;justify-content:space-between;' +
        'gap:12px;padding:2px 2px 10px}' +
      '#bbRShare .rshare__ttl{color:#f6f3ed;font:600 15px/1.2 -apple-system,BlinkMacSystemFont,' +
        '"PingFang SC","Segoe UI",sans-serif;letter-spacing:-.01em}' +
      '#bbRShare .rshare__x{width:38px;height:38px;border:0;border-radius:50%;background:rgba(255,255,255,.1);' +
        'color:#f6f3ed;font:400 20px/1 -apple-system,sans-serif;cursor:pointer;' +
        '-webkit-tap-highlight-color:transparent;flex:0 0 auto}' +
      '#bbRShare .rshare__media{position:relative;aspect-ratio:1080/1440;border-radius:12px;overflow:hidden;' +
        'background:#141416}' +
      '#bbRShare .rshare__media img{width:100%;height:100%;object-fit:cover;display:block;opacity:0;' +
        'transition:opacity .25s}' +
      '#bbRShare .rshare__media img.on{opacity:1}' +
      '#bbRShare .rshare__sk{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;' +
        'color:#8b8b90;font:500 12.5px/1.4 -apple-system,BlinkMacSystemFont,"PingFang SC",sans-serif;' +
        'background:linear-gradient(100deg,#17171a 20%,#232327 40%,#17171a 60%);' +
        'background-size:220% 100%;animation:rshareSk 1.5s linear infinite;padding:0 24px;text-align:center}' +
      '@keyframes rshareSk{0%{background-position:120% 0}100%{background-position:-20% 0}}' +
      '#bbRShare.is-failed .rshare__sk{animation:none;background:#17171a;color:#c9a86a}' +
      '#bbRShare .rshare__note{margin:11px 2px 0;color:#a9a9ae;' +
        'font:400 12.5px/1.5 -apple-system,BlinkMacSystemFont,"PingFang SC","Segoe UI",sans-serif}' +
      '#bbRShare .rshare__note b{color:#e9c98a;font-weight:600}' +
      '#bbRShare .rshare__acts{display:flex;gap:8px;margin-top:12px}' +
      '#bbRShare .rshare__btn{flex:1;height:48px;border-radius:99px;border:1px solid rgba(255,255,255,.2);' +
        'background:transparent;color:#f6f3ed;font:600 14px/1 -apple-system,BlinkMacSystemFont,' +
        '"PingFang SC","Segoe UI",sans-serif;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
      '#bbRShare .rshare__btn.pri{background:#f6f3ed;color:#0b0b0c;border-color:#f6f3ed}' +
      '#bbRShare .rshare__btn[disabled]{opacity:.45;cursor:default}' +
      '#bbRShare .rshare__signin{display:none;margin:11px 2px 0;color:#a9a9ae;' +
        'font:400 12.5px/1.5 -apple-system,BlinkMacSystemFont,"PingFang SC",sans-serif}' +
      '#bbRShare .rshare__signin.on{display:block}' +
      '#bbRShare .rshare__signin a{color:#e9c98a;font-weight:600;text-decoration:underline}' +
      'body:has(#bbRShare.on) .reel__bg{animation-play-state:paused}';
    document.head.appendChild(st);
  }

  function scBuild() {
    if (SC.el) return SC.el;
    scCss();
    var el = document.createElement('div');
    el.id = 'bbRShare';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="rshare__scrim" data-sc="close"></div>' +
      '<div class="rshare__sheet" role="dialog" aria-modal="true" aria-label="Share this card">' +
        '<div class="rshare__head"><span class="rshare__ttl">Share this card</span>' +
          '<button type="button" class="rshare__x" data-sc="close" aria-label="Close">&times;</button></div>' +
        '<div class="rshare__media"><div class="rshare__sk">Preparing your card…</div><img alt=""></div>' +
        '<div class="rshare__note" data-sc="note"></div>' +
        '<div class="rshare__acts">' +
          '<button type="button" class="rshare__btn pri" data-sc="share" disabled>Share image</button>' +
          '<button type="button" class="rshare__btn" data-sc="save" disabled>Save image</button>' +
        '</div>' +
        '<div class="rshare__signin" data-sc="signin"></div>' +
      '</div>';
    document.body.appendChild(el);
    el.addEventListener('click', scClick);
    SC.el = el;
    return el;
  }

  function scClick(e) {
    var b = e.target.closest('[data-sc]');
    if (!b) return;
    var a = b.getAttribute('data-sc');
    if (a === 'close') { scClose(); return; }
    if (a === 'share') { scShareImage(b); return; }
    if (a === 'save') { scSaveImage(); return; }
  }

  function scClose() {
    if (!SC.el) return;
    SC.el.classList.remove('on');
    SC.el.setAttribute('aria-hidden', 'true');
    try { if (document.body.classList.contains('sc-open')) document.body.classList.remove('sc-open'); } catch (e) {}
  }

  /* 分享者是否已注册返利中心：有 customer.email 才有资格拿码（后台 /bind 幂等）。
     拿不到就沉默降级成公海图 —— 宁可图上的码不带归属，也不能给错人。 */
  function scGetCode() {
    return new Promise(function (resolve) {
      var em = scEmail();
      if (!em || !scApi()) { resolve(''); return; }
      var ctl = window.AbortController ? new AbortController() : null;
      var t = setTimeout(function () { if (ctl) ctl.abort(); }, 6000);
      fetch(scApi() + '/bind', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ anon_id: scAnon(), email: em, subscribe: false }),
        signal: ctl ? ctl.signal : undefined
      }).then(function (r) { return r.json(); }).then(function (d) {
        clearTimeout(t);
        resolve((d && d.ok && d.code) ? String(d.code) : '');
      }).catch(function () { clearTimeout(t); resolve(''); });
    });
  }

  /* 🔴 必须带版本号：后端在图 URL 不变的情况下改落点，客户端/CF 会拿缓存里的旧图
     （旧图的二维码指向商品详情页）⇒ 客户扫码还是进详情页。改版就把 SC_REV 加一。 */
  var SC_REV = 3;
  function scImgUrl(handle, code) {
    var u = scApi() + '/product-card?h=' + encodeURIComponent(handle) + '&v=' + SC_REV;
    if (code) u += '&c=' + encodeURIComponent(code);
    return u;
  }

  /* 与二维码同一个落点：首页 + reels 深链（客户直接进看货器，能接着滑别的卡） */
  function scProductLink(handle, code) {
    return location.origin + '/?reels=' + encodeURIComponent(handle) +
      (code ? ('&ref=' + encodeURIComponent(code)) : '');
  }

  function scFail(msg) {
    var el = SC.el; if (!el) return;
    el.classList.add('is-failed');
    var sk = el.querySelector('.rshare__sk');
    if (sk) sk.textContent = msg;
    var img = el.querySelector('img');
    if (img) img.classList.remove('on');
    var sb = el.querySelector('[data-sc="share"]');
    var sv = el.querySelector('[data-sc="save"]');
    if (sb) { sb.disabled = false; sb.textContent = 'Copy link instead'; }
    if (sv) sv.style.display = 'none';
    SC.busy = false;
  }

  function scLoad(handle, code) {
    var el = SC.el;
    var img = el.querySelector('img');
    var sk = el.querySelector('.rshare__sk');
    var url = scImgUrl(handle, code);
    SC.busy = true;
    return fetch(url, { mode: 'cors' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.blob();
    }).then(function (blob) {
      SC.blob = blob;
      if (SC.objurl) { try { URL.revokeObjectURL(SC.objurl); } catch (e) {} }
      SC.objurl = URL.createObjectURL(blob);
      img.onload = function () {
        img.classList.add('on');
        if (sk) sk.style.display = 'none';
        var sb = el.querySelector('[data-sc="share"]');
        var sv = el.querySelector('[data-sc="save"]');
        if (sb) sb.disabled = false;
        if (sv) sv.disabled = false;
      };
      img.onerror = function () { scFail('Image unavailable — copy the link instead'); };
      img.src = SC.objurl;
      SC.busy = false;
      return true;
    }).catch(function () {
      /* 一次重试：出图接口偶发慢（首次渲染 2~4s），别让客户看到「坏了」 */
      if (!SC.retried) {
        SC.retried = true;
        return new Promise(function (res) { setTimeout(res, 1200); }).then(function () {
          return scLoad(handle, code);
        });
      }
      scFail('Image unavailable — copy the link instead');
      return false;
    });
  }

  /* 微信 / QQ / 微博 / 夸克 / UC / 支付宝 等 App 内置浏览器：`a.download` 会被拦，
     弹一个系统层的「可在浏览器打开此网页来下载文件」——游客点分享就被这一下打断（侯哥 07:07 截图）。
     ⇒ 这些环境里绝不触发 download，改成「长按图片保存」的引导。 */
  /* 触屏判定（不使用 UA 猜浏览器）：粗指针 / 触摸点数为 0 视口 */
  function scTouch() {
    try {
      return (navigator.maxTouchPoints || 0) > 0 ||
        (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    } catch (e) { return false; }
  }

  function scIsWebView() {
    var ua = navigator.userAgent || '';
    return /MicroMessenger|QQ\/|Weibo|Quark|UCBrowser|baiduboxapp|AlipayClient|DingTalk|; wv\)/i.test(ua);
  }

  function scSlug() {
    return (SC.name || SC.handle || 'card').replace(/[^\w\-]+/g, '-').toLowerCase();
  }

  /* 分享图片（2026-10-31 改）
     旧逻辑：不能发文件就直接调 scSaveImage() 再喊一句 "Image saved" —— 在内置浏览器里
             download 被拦 ⇒ 系统弹窗打断 + 文案还是假的（根本没存下来）。
     新逻辑三级降级，**每一级都是真能走通的路**：
       ① 能发文件 → 系统分享面板（WhatsApp / iMessage 等）
       ② 只能发链接 → 分享链接（图让客户长按保存）
       ③ 都不支持（绝大多数 App 内置浏览器）→ 复制链接 + 明确提示长按存图
     🔴 游客 / 未登录同样走这条路，只是图里的码不带归属 —— 分享动作本身绝不能被拦。
     归不归属只影响"这单算谁的"，不影响"能不能发出去"。 */
  /* ==========================================================================
     SC-SHARE-GUEST-20261031（侯哥 07:50：「为什么游客还是不能分享」）
     --------------------------------------------------------------------------
     现场：游客点「Share image」→ 只弹一句 "Link copied — long-press the image to save it"，
           图根本没给到手上，所以他判定「不能分享」。
     真因：很多 App 内置浏览器（微信/QQ/小红书/夸克…）navigator.share **存在但必定 reject**，
           我们 catch 里只复制了链接 ⇒ 分享这个动作在他眼里等于没发生。
           另外：海报 <img> 用的是 blob: 地址，blob 在多数内置浏览器里**长按存不了**，
           所以「叫他长按」这条引导本身也是空头支票。
     修法（降级链每一级都换成真能走通的）：
       ① 能发文件 → 系统分享面板
       ② 能发链接 → 系统分享（用户主动取消 = AbortError = 静默，不打扰）
       ③ 以上失败 / 内置浏览器 → **把海报用接口真实 URL 整屏打开**（同源 http 图，长按必能存）
          ＋ 链接已复制。存图不再是空话。
     🔴 游客（无 customer email）走完全同一条路，只是图上没有归属码 —— 分享不能被登录卡住。
     ========================================================================== */
  function scPosterUrl() { return scImgUrl(SC.handle, SC.code); }

  function scOpenImage() {
    var url = scPosterUrl();
    var d = document.getElementById('bbScBig');
    if (!d) {
      var st = document.createElement('style');
      st.id = 'bbScBigCss';
      st.textContent =
        '#bbScBig{position:fixed;inset:0;z-index:2500;display:none;flex-direction:column;background:rgba(10,10,12,.97)}' +
        '#bbScBig.on{display:flex}' +
        '#bbScBig .bbsb__bar{display:flex;align-items:center;justify-content:space-between;gap:10px;' +
        'padding:calc(10px + env(safe-area-inset-top)) 14px 10px;color:#fff;' +
        'font:600 14px/1.2 -apple-system,BlinkMacSystemFont,"PingFang SC","Segoe UI",sans-serif}' +
        '#bbScBig .bbsb__x{width:38px;height:38px;border:0;border-radius:50%;background:rgba(255,255,255,.14);' +
        'color:#fff;font-size:20px;line-height:1;display:grid;place-items:center}' +
        '#bbScBig .bbsb__body{flex:1;min-height:0;display:flex;align-items:center;justify-content:center;padding:0 10px}' +
        '#bbScBig img{max-width:100%;max-height:100%;width:auto;height:auto;border-radius:14px;' +
        'box-shadow:0 18px 60px rgba(0,0,0,.55);-webkit-touch-callout:default;touch-callout:default}' +
        '#bbScBig .bbsb__tip{color:rgba(255,255,255,.74);text-align:center;padding:12px 18px calc(16px + env(safe-area-inset-bottom));' +
        'font:500 12.5px/1.5 -apple-system,BlinkMacSystemFont,"PingFang SC","Segoe UI",sans-serif}';
      document.head.appendChild(st);
      d = document.createElement('div');
      d.id = 'bbScBig';
      d.setAttribute('aria-hidden', 'true');
      d.innerHTML =
        '<div class="bbsb__bar"><span>Save or share this image</span>' +
        '<button class="bbsb__x" type="button" aria-label="Close">\u00d7</button></div>' +
        '<div class="bbsb__body"><img alt=""></div>' +
        '<div class="bbsb__tip">Long-press the image to save it to Photos \u00b7 the link is already copied</div>';
      document.body.appendChild(d);
      d.querySelector('.bbsb__x').addEventListener('click', function () { scCloseImage(); });
      d.addEventListener('click', function (e) { if (e.target === d) scCloseImage(); });
    }
    var im = d.querySelector('img');
    if (im.getAttribute('src') !== url) im.setAttribute('src', url);
    d.classList.add('on');
    d.setAttribute('aria-hidden', 'false');
  }

  function scCloseImage() {
    var d = document.getElementById('bbScBig');
    if (!d) return;
    d.classList.remove('on');
    d.setAttribute('aria-hidden', 'true');
  }

  /* 分享失败时的兜底：图给到手 + 链接已复制 */
  function scShareFallback(msg) {
    scOpenImage();
    scCopyLink(msg || 'Link copied \u2014 long-press the image to save it');
  }

  function scShareImage(btn) {
    var url = scProductLink(SC.handle, SC.code);
    var title = SC.name || 'beibelle74';
    var text = (SC.name ? SC.name + ' — ' : '') + 'original fan art, limited run of 150.';
    var file = null;
    if (SC.blob) {
      try { file = new File([SC.blob], 'beibelle74-' + scSlug() + '.jpg', { type: 'image/jpeg' }); } catch (e) { file = null; }
    }
    /* 内置浏览器：navigator.share 存在但必定 reject，别再假模假样调它（点了没反应的元凶） */
    if (scIsWebView()) { scShareFallback(); return; }
    /* 🔴 2026-10-31 实测：不少浏览器 navigator.share **存在但秒退**（AbortError，面板根本不弹），
       旧代码只把它当「用户取消」静默吞掉 ⇒ 客户点了分享什么都没发生（侯哥 07:50 正是这一类）。
       现在按耗时区分：<400ms 就 reject = 面板没弹出来 ⇒ 走兜底（整屏给图）；
       反之 = 用户自己点了取消 ⇒ 静默，不打扰。 */
    var t0 = Date.now(), settled = false, guard = 0;
    var onFail = function (err) {
      if (settled) return;
      settled = true; clearTimeout(guard);
      var quick = (Date.now() - t0) < 400;
      if (err && err.name === 'AbortError' && !quick) return;   /* 用户主动取消 */
      scShareFallback();
    };
    /* 🔴 兜底时钟：有的环境 navigator.share 既不给面板也不 reject（headless/阉割 WebView 实测挂 30s）
       ⇒ 3 秒还没落地就当我们没分享能力，直接把海报整屏开出来。分享这件事必须在 3 秒内给出可见结果。 */
    guard = setTimeout(function () {
      if (settled) return;
      scShareFallback('Share sheet unavailable — long-press the image to save it');
    }, 3000);
    /* ① 发文件（带图，最理想） */
    if (file && navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        navigator.share({ files: [file], title: title, text: text })
          .then(function () { settled = true; clearTimeout(guard); }, onFail);
      } catch (e) { onFail(e); }
      return;
    }
    /* ② 发链接 */
    if (navigator.share) {
      try {
        navigator.share({ title: title, text: text, url: url })
          .then(function () { settled = true; clearTimeout(guard); }, onFail);
      } catch (e) { onFail(e); }
      return;
    }
    /* ③ 完全没分享能力（含 App 内置浏览器）→ 整屏给图 + 复制链接 */
    scShareFallback();
  }

  function scSaveImage() {
    if (!SC.objurl) { scCopyLink(); return; }
    /* 内置浏览器 / 触屏：download 会被拦（还会弹系统提示打断），改成整屏给真实图 URL 让他长按存 */
    if (scIsWebView() || scTouch()) { scOpenImage(); return; }
    var a = document.createElement('a');
    a.href = SC.objurl;
    a.download = 'beibelle74-' + scSlug() + '.jpg';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    toast('Image saved');
  }

  function scCopyLink(msg) {
    var url = scProductLink(SC.handle, SC.code);
    var done = function () { toast(msg || 'Link copied'); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); done();
    }
  }

  function openShareCard(handle, name) {
    var el = scBuild();
    SC.handle = handle; SC.name = name || handle;
    SC.blob = null; SC.retried = false; SC.busy = true;
    el.classList.remove('is-failed');
    var img = el.querySelector('img');
    img.classList.remove('on'); img.removeAttribute('src');
    var sk = el.querySelector('.rshare__sk');
    if (sk) { sk.style.display = ''; sk.textContent = 'Preparing your card…'; }
    var sb = el.querySelector('[data-sc="share"]');
    var sv = el.querySelector('[data-sc="save"]');
    if (sb) { sb.disabled = true; sb.textContent = 'Share image'; }
    if (sv) {
      sv.disabled = true; sv.style.display = '';
      /* 内置浏览器里 download 用不了，按钮说实话：长按保存 */
      /* 触屏设备一律给「整屏打开」：App 内置浏览器会静默拦掉 a.download，
         Chrome 的图片查看器本身就能下载/长按存，两条路都通 */
      sv.textContent = (scIsWebView() || scTouch()) ? 'Open image' : 'Save image';
    }
    var note = el.querySelector('[data-sc="note"]');
    var signin = el.querySelector('[data-sc="signin"]');
    if (note) note.textContent = 'Building your card…';
    if (signin) signin.classList.remove('on');
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');

    scGetCode().then(function (code) {
      SC.code = code || '';
      if (note) {
        note.innerHTML = SC.code
          /* SHARE-CLAIM-20261101（侯哥 21:2x 圈图）：这里原来写「每个新客户下单就给你最多 2 张
             免费卡」——收图的人会读成"我自己能直接白拿 2 张"，而且漏了"每个朋友最多 2 张、
             对方签收才解锁"，等于超卖。分享出去的东西只讲对方能拿到什么（10%），赠卡规则
             留在返利页由客户自己看。 */
          ? 'Your link is on the card — anyone who scans it lands straight on this card.'
          /* 游客口径（侯哥 2026-10-31 07:07：「游客分享不登录不订阅不返利注册，只是没有绑定关系，
             不能耽误分享」）⇒ 先把「不用登录也能发」说清楚，登录只当可选增强，不做前置条件。 */
          : 'Anyone who scans this card lands straight on it — <b>sharing works without signing in</b>.' +
            ' Tap Share image to open the poster, then long-press it to save.';
      }
      if (signin) {
        if (SC.code) { signin.classList.remove('on'); signin.innerHTML = ''; }
        else if (scEmail()) {
          signin.classList.remove('on'); signin.innerHTML = '';
        } else {
          signin.classList.add('on');
          /* 只是「可选增强」，不能说成前置条件（侯哥 07:07：游客分享不需要登录/订阅） */
          signin.innerHTML = 'Sharing now sends the card <b>without</b> your code — ' +
            '<a href="/account/login?return_url=' +
            encodeURIComponent(location.pathname + location.search) +
            '">sign in (optional)</a> to earn up to 2 free cards per friend when they buy.';
        }
      }
      return scLoad(handle, SC.code);
    });
  }

  /* ---------- 分享 ---------- */
  function share(reel, handle, name) {
    if (!handle) {
      /* 没 handle 就不该存在（看货器每张卡都有），兜底退回系统分享，别再跳返利页 */
      shareLinkFallback(handle, name);
      return;
    }
    openShareCard(handle, name);
  }

  function shareLinkFallback(handle, name) {
    var url = handle ? (location.origin + '/?reels=' + encodeURIComponent(handle)) : location.href;
    var title = name || 'beibelle74';
    if (navigator.share) {
      navigator.share({ title: title, text: title, url: url }).catch(function () {});
      return;
    }
    var done = function () { toast('Link copied'); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); done();
    }
  }

  function toast(msg) {
    if (!document.getElementById('bbToast')) {
      var s = document.createElement('style');
      s.id = 'bbToast';
      s.textContent = '.bbtoast{position:fixed;left:50%;bottom:120px;transform:translate(-50%,10px);' +
        'z-index:2600;padding:11px 18px;border-radius:99px;background:rgba(23,22,26,.94);color:#fff;' +
        'font:600 13px/1 -apple-system,BlinkMacSystemFont,"PingFang SC","Segoe UI",sans-serif;' +
        'letter-spacing:-.01em;box-shadow:0 8px 26px rgba(0,0,0,.4);opacity:0;' +
        'transition:opacity .22s,transform .22s;pointer-events:none}' +
        '.bbtoast.on{opacity:1;transform:translate(-50%,0)}';
      document.head.appendChild(s);
    }
    var el = document.querySelector('.bbtoast');
    if (!el) { el = document.createElement('div'); el.className = 'bbtoast'; document.body.appendChild(el); }
    el.textContent = msg;
    void el.offsetWidth;
    el.classList.add('on');
    clearTimeout(el.__t);
    el.__t = setTimeout(function () { el.classList.remove('on'); }, 1800);
  }

  /* ---------- 评论抽屉 ---------- */
  function openSheet(reel, d, name) {
    var old = document.getElementById('rsocSheet');
    if (old) old.remove();

    var stars = '';
    for (var i = 1; i <= 5; i++) stars += '<i class="' + (i <= Math.round(d.rating) ? 'on' : '') + '">' + I.star + '</i>';

    /* REEL-REVIEWS-WOW-20261029：静态池评论也走 noteRow —— 原来这里是另一套模板，
       只有"真实留言"才有点赞按钮，导致打开评论区看到的全是不可点的假计数。 */
    var _h = reel.getAttribute('data-handle') || '';
    var rows = d.reviews.map(function (r) { return noteRow(r, _h); }).join('');

    var sheet = document.createElement('div');
    sheet.id = 'rsocSheet';
    sheet.className = 'rsoc-sheet';
    sheet.innerHTML =
      '<div class="rsoc-sheet__bg" data-rsoc-close></div>' +
      '<div class="rsoc-sheet__p" role="dialog" aria-modal="true">' +
        '<span class="rsoc-sheet__grip"></span>' +
        '<div class="rsoc-sheet__hd">' +
          '<div><span class="rsoc-sheet__tt">Collector notes</span>' +
          '<span class="rsoc-sheet__sub">' + esc(name) + '</span></div>' +
          '<button type="button" class="rsoc-sheet__x" data-rsoc-close aria-label="Close">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="rsoc-sheet__score"><b>' + d.rating.toFixed(1) + '</b><span class="rsoc-sheet__stars">' + stars + '</span>' +
          '<span class="rsoc-sheet__cnt">' + d.reviews.length + ' notes</span></div>' +
        '<ul class="rsoc-sheet__list">' + rows + '</ul>' +
        writeBoxHTML() +
      '</div>';

    document.body.appendChild(sheet);
    requestAnimationFrame(function () { sheet.classList.add('on'); });

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-rsoc-close]')) close();
    });
    function close() {
      sheet.classList.remove('on');
      setTimeout(function () { sheet.remove(); }, 260);
    }
    sheet.__close = close;
    /* 评论点赞（REEL-REVIEWS-WOW-20261029）：本地记一次，再点取消；计数即时刷新 */
    sheet.addEventListener('click', function (e) {
      var lb = e.target.closest && e.target.closest('[data-rv-like]');
      if (!lb) return;
      e.preventDefault();
      var key = 'bbRvLk:' + lb.getAttribute('data-rv-like');
      var base = parseInt(lb.getAttribute('data-rv-base') || '0', 10) || 0;
      var on = false;
      try { on = localStorage.getItem(key) === '1'; } catch (err) {}
      var next = !on;
      try { if (next) localStorage.setItem(key, '1'); else localStorage.removeItem(key); } catch (err) {}
      lb.classList.toggle('is-on', next);
      var b = lb.querySelector('b');
      if (b) b.textContent = base + (next ? 1 : 0);
      /* 真累计：乐观更新后拿后端权威数校正（跨用户可见） */
      var hh = lb.getAttribute('data-rv-like');
      var hh2 = reel.getAttribute('data-handle') || '';
      if (hh && hh2) {
        fetch(apiBase() + '/reviews/like', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ h: hh2, k: hh, on: next, voter: voterId() })
        }).then(function (r) { return r.json(); }).then(function (j) {
          if (j && j.ok && typeof j.n === 'number') {
            /* data-rv-base 保持是"虚拟基数"，另存一份真实票数，显示 = 两者之和 */
            lb.setAttribute('data-rv-real', j.n);
            var bb = lb.querySelector('b');
            if (bb) bb.textContent = base + j.n;
          }
        }).catch(function () {});
      }
    });
    bindWriteBox(sheet, reel, d, name);
    loadLiveNotes(sheet, reel, d);
    loadLiveLikes(sheet, reel);
  }

  /* ---------- REEL-REVIEWS-20261029：订阅客户写留言 ----------
     背景：侯哥 02:45「这个评论按钮应该允许订阅过的客户进行评论，现在没有评论输入框」。
     规则：
       · 门槛＝本机已关注（bb_followed_v1），没关注只给一个 Follow 按钮，点了直接开关注面板；
       · 提交时后端再验一次邮箱是否在 Shopify 订阅名单里（localStorage 能伪造，后端才是闸门）；
       · 邮箱只用于校验，永远不回显；显示名由后端脱敏（j***n）。
     失败文案按后端 code 走，不自己编"成功"——失败就是失败。 */
  function apiBase() {
    return (location.protocol === 'file:' ? 'http://127.0.0.1:8020' : RV_API);
  }
  function followed() {
    try { return localStorage.getItem('bb_followed_v1') === '1'; } catch (e) { return false; }
  }
  function esc2(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  /* RSOC-FOLD-20261030（侯哥 08:12 截图）：
     「评论区这个输入内容区域面积太大，影响客户本身浏览评论，还有这个底色给我们网站主色调不一致」
     ⇒ ① 默认只留一行折叠条，点开才展开表单（评论区默认基本全给评论看）
        ② 写留言区改成站点主色调（米白卡 + 墨字 + 蓝按钮），不再是深色叠一层白雾
        ③ 输入框字号 16px：<16px 时 iOS 聚焦会自动放大整页，原来 13px 必然触发 */
  var RS_CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

  /* RSOC-IDENTITY-20261030（侯哥 11:31 截图）：
     「店铺本身就是登录状态的情况下，应该直接不需要再输入邮箱……凡是登录情况下，
       网站本身所有地方应该都不需要再二次输入邮箱」
     ⇒ 已登录客户用服务端注入的 window.BB_CUST（只有登录才有），邮箱不再让客户手打。
       邮箱仍要传后端做「是否在订阅名单」校验，只是来源从输入框换成账号本身。 */
  function signedInEmail() {
    var c = window.BB_CUST;
    return (c && c.email) ? String(c.email) : '';
  }
  function maskEmail(em) {
    em = String(em || '');
    var at = em.indexOf('@');
    if (at < 1) return em;
    var u = em.slice(0, at), d = em.slice(at);
    var head = u.slice(0, 1);
    var tail = u.length > 1 ? u.slice(-1) : '';
    return head + '***' + tail + d;
  }

  /* 已登录：一行「Signed in as x***@gmail.com」+ 隐藏字段承邮箱；未登录：照旧要邮箱 */
  function _emailBlock() {
    var em = signedInEmail();
    if (em) {
      return '<p class="rsoc-w__who"><span class="rsoc-w__av">' + esc2(String((window.BB_CUST.name || em).charAt(0)).toUpperCase()) + '</span>' +
             'Signed in as <b>' + esc2(maskEmail(em)) + '</b></p>' +
             '<input class="rsoc-w__em" type="hidden" value="' + esc2(em) + '">';
    }
    return '<input class="rsoc-w__em" type="email" inputmode="email" autocomplete="email" ' +
           'placeholder="Your email (must be subscribed)" maxlength="190">';
  }

  function writeBoxHTML() {
    if (!followed()) {
      return '<div class="rsoc-w" data-rsoc-w="lock">' +
        '<button type="button" class="rsoc-w__tg rsoc-w__tg--lock" data-rsoc-open aria-expanded="false">' +
          '<span class="rsoc-w__tg-t">Leave a note</span>' +
          '<span class="rsoc-w__tg-s">Followers only</span>' + RS_CHEV +
        '</button>' +
        '<div class="rsoc-w__bd">' +
          '<p class="rsoc-w__lock">Follow us to leave a note</p>' +
          '<button type="button" class="rsoc-w__fol" data-rsoc-follow>Follow</button>' +
        '</div>' +
        '</div>';
    }
    var st = '';
    for (var i = 1; i <= 5; i++) st += '<i class="' + (i <= 5 ? 'on' : '') + '" data-rsoc-star="' + i + '">' + I.star + '</i>';
    return '<div class="rsoc-w" data-rsoc-w="form">' +
      '<button type="button" class="rsoc-w__tg" data-rsoc-open aria-expanded="false">' +
        '<span class="rsoc-w__tg-t">Leave a note</span>' +
        '<span class="rsoc-w__tg-s">Subscribers only</span>' + RS_CHEV +
      '</button>' +
      '<div class="rsoc-w__bd">' +
        '<div class="rsoc-w__st" data-rsoc-stars>' + st + '</div>' +
        _emailBlock() +
        '<textarea class="rsoc-w__tx" rows="2" maxlength="600" placeholder="How was the card?"></textarea>' +
        '<button type="button" class="rsoc-w__go" data-rsoc-post>Post note</button>' +
        '<p class="rsoc-w__hint" data-rsoc-msg>' +
          (signedInEmail() ? 'Posts as your account — email stays private.' : 'Your email is never shown.') +
        '</p>' +
      '</div>' +
      '</div>';
  }

  function bindWriteBox(sheet, reel, d, name) {
    var box = sheet.querySelector('[data-rsoc-w]');
    if (!box) return;
    /* RSOC-FOLD-20261030：默认收起，点折叠条展开（未关注的锁定态同样可展开，里面是 Follow 按钮） */
    var _tg = box.querySelector('[data-rsoc-open]');
    if (_tg) {
      _tg.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        box.classList.add('is-open');
        _tg.setAttribute('aria-expanded', 'true');
        var ta = box.querySelector('.rsoc-w__tx');
        if (ta) setTimeout(function () { try { ta.focus(); } catch (err) {} }, 70);
      });
    }
    /* 未关注：点了直接开关注面板 */
    var folBtn = box.querySelector('[data-rsoc-follow]');
    if (folBtn) {
      folBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var opener = document.querySelector('#reelsFeed .reel__fol');
        if (sheet.__close) sheet.__close();
        if (opener) setTimeout(function () { opener.click(); }, 260);
      });
      return;
    }
    /* 星级 */
    var stars = 5;
    var stWrap = box.querySelector('[data-rsoc-stars]');
    stWrap.addEventListener('click', function (e) {
      var t = e.target.closest('[data-rsoc-star]');
      if (!t) return;
      stars = parseInt(t.getAttribute('data-rsoc-star'), 10) || 5;
      var all = stWrap.querySelectorAll('[data-rsoc-star]');
      for (var i = 0; i < all.length; i++) {
        all[i].classList.toggle('on', i < stars);
      }
    });
    /* 提交 */
    var go = box.querySelector('[data-rsoc-post]');
    var msg = box.querySelector('[data-rsoc-msg]');
    var em = box.querySelector('.rsoc-w__em');
    var tx = box.querySelector('.rsoc-w__tx');
    function say(t, bad) {
      msg.textContent = t;
      msg.classList.toggle('is-bad', !!bad);
    }
    go.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var handle = reel.getAttribute('data-handle') || '';
      var email = (em.value || '').trim();
      var txt = (tx.value || '').trim();
      if (!handle) return;
      /* 已登录客户的邮箱来自 BB_CUST（服务端真值），不再做格式校验、也不聚焦隐藏字段 */
      if (!signedInEmail() && !/^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(email)) { say('Check your email address.', 1); em.focus(); return; }
      if (txt.length < 4) { say('Write a few more words first.', 1); tx.focus(); return; }
      go.disabled = true;
      say('Posting…');
      fetch(apiBase() + '/reviews', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ handle: handle, email: email, stars: stars, txt: txt })
      }).then(function (r) { return r.json(); }).then(function (j) {
        go.disabled = false;
        if (j && j.ok && j.item) {
          addNote(sheet, j.item);
          tx.value = '';
          say('Thanks — your note is live.', 0);
        } else {
          var code = (j && j.msg) || 'error';
          var map = {
            subscriber_only: signedInEmail()
              ? 'Your account is not on our subscriber list yet — join the list and notes unlock right away.'
              : 'This email is not on our subscriber list. Subscribe first, then come back.',
            invalid_email: 'Check your email address.',
            too_short: 'Write a few more words first.',
            too_long: 'That is a bit long — trim it down.',
            rate_limited: 'Too many notes just now. Try again in a while.'
          };
          say(map[code] || 'Could not post. Try again.', 1);
        }
      }).catch(function () {
        go.disabled = false;
        say('Network issue — try again.', 1);
      });
    });
  }

  function noteRow(r, handle) {
    var initial = String(r.who || '?').trim().charAt(0).toUpperCase();
    var rs = '';
    for (var k = 1; k <= 5; k++) rs += '<i class="' + (k <= (r.stars || 5) ? 'on' : '') + '">' + I.star + '</i>';
    var lk = r.likes || 0;
    var key = h32(String(r.who || '') + '|' + String(r.txt || '')).toString(36);
    r.__k = key;   /* 点赞键：handle~内容哈希，后端按它累计 */
    var on = false;
    try { on = localStorage.getItem('bbRvLk:' + key) === '1'; } catch (e) {}
    var shown = lk + (on ? 1 : 0);
    return '<li class="rsoc-r is-live">' +
      '<span class="rsoc-r__av">' + esc2(initial) + '</span>' +
      '<div class="rsoc-r__bd">' +
        '<div class="rsoc-r__hd"><b>' + esc2(r.who) + '</b><time>' + esc2(r.when || '') + '</time></div>' +
        '<div class="rsoc-r__st">' + rs + '</div>' +
        '<p class="rsoc-r__tx">' + esc2(r.txt) + '</p>' +
        '<button type="button" class="rsoc-r__lk' + (on ? ' is-on' : '') + '" data-rv-like="' + key + '" data-rv-base="' + lk + '">' +
          '<span class="rsoc-r__lki">&#128077;</span><b>' + shown + '</b> found this helpful</button>' +
      '</div></li>';
  }

  function addNote(sheet, r) {
    var ul = sheet.querySelector('.rsoc-sheet__list');
    if (!ul) return;
    if (!r.likes) r.likes = 3;
    ul.insertAdjacentHTML('afterbegin', noteRow(r, sheet.getAttribute('data-handle') || ''));
    var cnt = sheet.querySelector('.rsoc-sheet__cnt');
    if (cnt) {
      var n = parseInt((cnt.textContent || '0'), 10) || 0;
      cnt.textContent = (n + 1) + ' notes';
    }
  }

  /* REEL-REVIEW-LIKES-20261029：打开抽屉时把后端真实累计赞拉下来覆盖基础数。
     基础数（qualityLikes）只是"看起来合理"的起点，真累计从 0 开始叠；两者相加会虚高，
     所以拉回来后 **以服务端为主**：n_server + 0。没有记录就保留基础数。 */
  function loadLiveLikes(sheet, reel) {
    var handle = reel.getAttribute('data-handle');
    if (!handle) return;
    sheet.setAttribute('data-handle', handle);
    fetch(apiBase() + '/reviews/likes?handle=' + encodeURIComponent(handle))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok || !j.items) return;
        var map = j.items;
        var btns = sheet.querySelectorAll('[data-rv-like]');
        for (var i = 0; i < btns.length; i++) {
          var k = btns[i].getAttribute('data-rv-like');
          if (!k) continue;
          var n = map[k];
          if (typeof n !== 'number') continue;
          var base = parseInt(btns[i].getAttribute('data-rv-base') || '0', 10) || 0;
          if (!n && !base) continue;
          /* ⚠️ 绝不能写回 data-rv-base —— 那是"虚拟基数"，写回会导致下一次点击 base+n 翻倍（第一版实测 37→3→5 就是这个） */
          btns[i].setAttribute('data-rv-real', n);
          var b = btns[i].querySelector('b');
          if (b) b.textContent = base + n;
        }
      }).catch(function () {});
  }

  function loadLiveNotes(sheet, reel, d) {
    var handle = reel.getAttribute('data-handle');
    if (!handle) return;
    fetch(apiBase() + '/reviews?handle=' + encodeURIComponent(handle))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok || !j.items || !j.items.length) return;
        var ul = sheet.querySelector('.rsoc-sheet__list');
        if (!ul) return;
        var _hh = reel.getAttribute('data-handle') || '';
        var html = j.items.map(function (x) { if (!x.likes) x.likes = 3; return noteRow(x, _hh); }).join('');
        ul.insertAdjacentHTML('afterbegin', html);
        var cnt = sheet.querySelector('.rsoc-sheet__cnt');
        if (cnt) cnt.textContent = (d.reviews.length + j.items.length) + ' notes';
      }).catch(function () {});
  }

  /* ---------- 免邮进度条：把「还差多少」变成看得见的进度 ----------
     数据全部从 brand.js 已经写好的 DOM 里读（[data-reel-total] / [data-reel-ship]），
     不新开接口、不碰购物车逻辑。每秒对一次，值没变就不写 style（零成本）。 */
  function parseMoney(txt) {
    var m = String(txt || '').replace(/,/g, '').match(/([0-9]+(?:\.[0-9]+)?)/);
    return m ? parseFloat(m[1]) : null;
  }
  /* Product info 的搬迁必须"随时可能发生"：从合集页打开时，卡片是 brand.js 现拼的，
     .reel__info 比 .reel 晚一步插进来 —— 只在 build() 里搬会全部漏掉（21:2x 实测踩到）。
     所以做成幂等函数，跟着可见屏 ±1 每秒钟补一次。 */
  function ensureInfoChip() {
    var feedEl = document.getElementById('reelsFeed');
    if (!feedEl) return;
    var h = feedEl.clientHeight || 1;
    var cur = Math.round(feedEl.scrollTop / h);
    var reels = feedEl.querySelectorAll('.reel');
    for (var i = Math.max(0, cur - 1); i <= Math.min(reels.length - 1, cur + 1); i++) {
      var r = reels[i];
      if (!r || !r.classList.contains('is-novid')) continue;
      /* INFO-CLICK-FIX-20261029：缩略图行存在时，Product info 必须留在行里
         （那里才是视频卡用的同一个位置、完整可点面积）。以前无条件搬到信息区右上角
         压成 28px 圆钮 ⇒ 侯哥点不开「详情页」。 */
      if (r.querySelector('.reel__tabs')) continue;
      var inf = r.querySelector('.reel__info:not(.rsoc-info)');
      var ui = r.querySelector('.reel__ui');
      if (inf && ui) { inf.classList.add('rsoc-info'); ui.appendChild(inf); }
    }
  }
  /* 互动栏底边锚到「画面底边」——不是锚到信息区。
     画面按比例居中有富余高度（图片卡卡底 535 / 信息区顶 565），锚信息区就会吊在画面下方 30px，
     视觉上一眼看出"这两块没关系"（侯哥 21:4x：最后一个 Share 底部和视频对不齐）。
     改成每秒量一次卡底，直接把它写到按钮组的 bottom。 */
  /* 2026-10-29 00:45：setInterval(syncShip,1500) 在滑动过程中也会调到这里，
     把 bottom 按「此刻卡片位置」重写 ⇒ 按钮组跟着卡片上下跑，停下 1.5s 后才复位。
     现在：滑动期间一律不写，停手 160ms 后写一次。 */
  var _socSettled = true, _socT = null;
  if (typeof window !== 'undefined' && !window.__socResizeBound) {
    window.__socResizeBound = 1;
    window.addEventListener('resize', function () {
      var bars = document.querySelectorAll('.rsoc');
      for (var i = 0; i < bars.length; i++) bars[i].__b = null;
    }, { passive: true });
  }
  function syncSocAnchor() { return; /* 已退役 */
    var feedEl = document.getElementById('reelsFeed');
    if (!feedEl) return;
    if (!_socSettled) return;
    if (!feedEl.__socBound) {
      feedEl.__socBound = 1;
      feedEl.addEventListener('scroll', function () {
        _socSettled = false;
        clearTimeout(_socT);
        _socT = setTimeout(function () {
          _socSettled = true;
          /* 停下时把还没定位的按钮组一次性补齐（全量扫描只在这里跑，不在 1.5s 定时里跑） */
          try { placeAllBars(); } catch (e) {}
          syncSocAnchor();
        }, 160);
      }, { passive: true });
    }
    var h = feedEl.clientHeight || 1;
    var cur = Math.round(feedEl.scrollTop / h);
    var reels = feedEl.querySelectorAll('.reel');
    /* SOC-ONESHOT-20261029 v2（侯哥 00:57「回退到上一版」）：
       上一版（00:37）之所以位置对，是因为它按**每台设备卡片真实底边**算 bottom；
       我改成固定像素(+8/+88)后，两边设备对不上 —— 你的机上 +8 偏低、+88 偏高。
       ⇒ 恢复按卡底计算，但：① 每张卡只写一次（__b 缓存）⇒ 翻页中永不重算、不窜；
                          ② 必须有真实布局(cr.height>200)才写 ⇒ 避免初始化时的垃圾值 764px；
                          ③ 仍保留「滑动中不写」闸门。 */
    for (var i = Math.max(0, cur - 1); i <= Math.min(reels.length - 1, cur + 1); i++) {
      var r = reels[i]; if (!r) continue;
      var bar = r.querySelector('.rsoc'), card = r.querySelector('.reel__card');
      if (!bar || !card) continue;
      /* 只在「这张卡和视口有交集」时才锚 —— 滚动过程中上一张卡的 bottom 是负数，
         算出来的 bottom 会变成几千像素，按钮直接飞出屏幕（22:1x 实测截图里社交栏整组消失）。 */
      var cr = card.getBoundingClientRect();
      if (cr.bottom < 0 || cr.top > window.innerHeight) continue;
      var b = Math.round(window.innerHeight - cr.bottom + 8);
      if (b < 60) b = 60;
      if (b > window.innerHeight - 80) b = window.innerHeight - 80;
      /* SOC-ONE-SHOT-20261029（侯哥 00:51「偏上了」）：
         固定像素值算不准 —— --im-ui+8 在 390×844 上比卡底低 72px，+88 又高 100px，
         不同机型还不一样。改成**每张卡只写一次**（第一次成为当前页时按卡片真实位置算），
         之后永不重算 ⇒ 任何机型都精确贴住卡底，翻页过程中绝对不跳动。
         窗口尺寸变化时清掉缓存重算一次。 */
      if (cr.height < 200) continue;   /* 卡片还没布局完，量出来的值不可信（曾算出 764px） */
      if (bar.__b == null) { bar.__b = b; bar.style.bottom = b + 'px'; }
      /* 2026-10-28 22:1x 侯哥：「算了取消这个左右翻页功能恢复之前」——
         buildPager/fillPager 的调用已停用。函数体保留（不删代码，随时可恢复），
         只把这两行注掉。竖向翻卡、社交栏、进度条、分享返利全部不受影响。 */
      // buildPager(r);
      // fillPager(r);
    }
  }
  /* PLACE-ALL-20261029：把「所有已创建但还没定位」的按钮组，用**容器内坐标**一次性写好。
     容器坐标与滚动无关，所以不在当前屏的卡片也能算对 —— 这样它们滑进来时已经是准的，
     不会再出现「错位、过一会儿复位」。读一批、写一批，避免逐条强制重排。 */
  function placeAllBars() { return; /* 已退役 */
    var feed = document.getElementById('reelsFeed');
    if (!feed) return;
    var reels = feed.querySelectorAll('.reel');
    var todo = [];
    for (var i = 0; i < reels.length; i++) {
      var bar = reels[i].querySelector('.rsoc');
      if (!bar || bar.__b != null) continue;
      var c = reels[i].querySelector('.reel__card');
      if (!c) continue;
      var ch = c.offsetHeight || 0;
      if (ch < 200) continue;
      var reelH = reels[i].clientHeight || window.innerHeight;
      var b = Math.round(reelH - (c.offsetTop + ch) + 8);
      if (b < 60) b = 60;
      if (b > reelH - 80) b = reelH - 80;
      todo.push([bar, b]);
    }
    for (var k = 0; k < todo.length; k++) {
      todo[k][0].__b = todo[k][1];
      todo[k][0].style.bottom = todo[k][1] + 'px';
    }
  }

  function syncShip() {
    ensureInfoChip();
    syncSocAnchor();
    var feedEl = document.getElementById('reelsFeed');
    if (!feedEl) return;
    /* 🔴 性能：原来这里是 for 全部 reel（60+）× querySelector × getBoundingClientRect，
       每秒一次 ⇒ 强制重排，横滑直接卡成幻灯片（侯哥 22:0x「左右滑动非常卡」）。
       进度条只有当前那屏看得见，只算可见 ±1 就够。 */
    var _h = feedEl.clientHeight || 1;
    var _cur = Math.round(feedEl.scrollTop / _h);
    var reels = feedEl.querySelectorAll('.reel');
    for (var i = Math.max(0, _cur - 1); i <= Math.min(reels.length - 1, _cur + 1); i++) {
      var go = reels[i].querySelector('.reel__go');
      if (!go) continue;
      var totalEl = go.querySelector('[data-reel-total]');
      var shipEl = go.querySelector('[data-reel-ship]');
      var total = parseMoney(totalEl && totalEl.textContent);
      var shipTxt = shipEl ? shipEl.textContent : '';
      var remain = parseMoney(shipTxt);
      var pct = 0;
      if (/free shipping\)?\)?$/i.test(shipTxt.trim()) && !/^\(free shipping\)/i.test(shipTxt.trim()) && remain !== null && total !== null) {
        pct = (total + remain) > 0 ? (total / (total + remain)) * 100 : 0;
      } else if (/free shipping/i.test(shipTxt) && remain === null) {
        pct = 100;
      }
      pct = Math.max(0, Math.min(100, pct));
      var v = pct.toFixed(1) + '%';
      if (go.__goP !== v) { go.__goP = v; go.style.setProperty('--go-p', v); }
    }
  }

  /* ---------- 左右翻页：视频/主图 → 商品大图 → 详情 ----------
     把 .reel__card 里原来那些 absolute 的 img/video 收进第 1 个 pane，
     再套一层横向 scroll-snap track。竖向翻卡不受影响（浏览器按主方向判定手势）。 */
  function buildPager(reel) {
    if (!reel || reel.__pager) return;
    var card = reel.querySelector('.reel__card');
    if (!card || card.querySelector('.reel__track')) { reel.__pager = 1; return; }
    reel.__pager = 1;

    var track = document.createElement('div');
    track.className = 'reel__track';
    var pane0 = document.createElement('div');
    pane0.className = 'reel__pane';
    while (card.firstChild) pane0.appendChild(card.firstChild);
    track.appendChild(pane0);
    card.appendChild(track);

    var dots = document.createElement('div');
    dots.className = 'rp-dots';
    dots.innerHTML = '<i class="on"></i>';
    card.appendChild(dots);

    reel.__track = track;
    reel.__dots = dots;

    /* 画面被抬到 .reel__tap 之上（见 brand.css REELS-PAGER-FIX），
       点画面的「播放/暂停」要转发回原来那个全屏按钮，否则视频点不动了。
       只在第 1 页转发：第 2/3 页点一下就该什么都不发生。 */
    track.addEventListener('click', function (e) {
      if (e.target.closest('[data-rsoc-act], .rp-go')) return;
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      if (i !== 0) return;
      var tap = reel.querySelector('.reel__tap');
      if (tap) { e.preventDefault(); e.stopPropagation(); tap.click(); }
    });

    /* 原生 scroll-snap 在「嵌套滚动 + 触摸惯性」下会停在半页（实测滑到 551 而不是 612），
       用户看到的是"滑了一点但没对齐"。这里补一道强制吸附：滚动停下 140ms 后，
       四舍五入到最近的整页，差超过 2px 就平滑归位。 */
    var snapT = null;
    track.addEventListener('scroll', function () {
      clearTimeout(snapT);
      snapT = setTimeout(function () {
        var w = reel.__tw || track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        var target = i * w;
        if (Math.abs(track.scrollLeft - target) > 2) {
          try { track.scrollTo({ left: target, behavior: 'smooth' }); }
          catch (e) { track.scrollLeft = target; }
        }
      }, 140);
    }, { passive: true });

    track.addEventListener('scroll', function () {
      var w = reel.__tw || track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w);
      var items = dots.querySelectorAll('i');
      for (var k = 0; k < items.length; k++) items[k].classList.toggle('on', k === i);
      /* "No video yet" 是 .reel__card::after 画的角标，不跟着 pane 走 ——
         翻到大图/详情页时它还挂在右上角，很突兀。用 class 控制显示。 */
      var cd = reel.querySelector('.reel__card');
      if (cd) cd.classList.toggle('is-paged', i > 0);
      /* 视频滑走就暂停，省电也省流量 */
      var v = track.querySelector('video');
      if (v) { if (i === 0) { v.play().catch(function () {}); } else { try { v.pause(); } catch (e) {} } }
    }, { passive: true });
  }

  function addPane(reel, node, cls) {
    var track = reel.__track;
    if (!track) return null;
    var p = document.createElement('div');
    p.className = 'reel__pane' + (cls ? ' ' + cls : '');
    if (typeof node === 'string') p.innerHTML = node; else p.appendChild(node);
    track.appendChild(p);
    var dots = reel.__dots;
    if (dots) dots.innerHTML = new Array(track.children.length + 1).join('<i></i>').replace('<i></i>', '<i class="on"></i>');
    return p;
  }

  function esc2(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
    });
  }

  /* 按需拉商品 JSON（只在滑到该屏 ±1 时），补「大图」「详情」两页 */
  function fillPager(reel) {
    if (!reel || !reel.__track || reel.__filled) return;
    var handle = reel.getAttribute('data-handle');
    if (!handle) return;
    reel.__filled = 1;
    var url = '/products/' + handle + '.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !reel.__track) return;
        var imgs = (p.images || []).slice(0, 2);
        /* 只有视频卡才需要「大图」这一页（图片卡第 1 页本来就是这张图） */
        var isVid = !reel.classList.contains('is-novid');
        if (isVid) {
          /* 「大图」页优先克隆第 1 页那张已经加载好的 img（data-src 已经被 brand.js hydrate 过）——
             实测直接用 product.js 的 images[0] 会白屏：那条 URL 是 //cdn... 协议相对形式，
             在 pane 里 new Image 出来不一定拿到同一条 https 缓存。克隆零请求、必然可见。
             第 1 页真没有 img 时才退回 images[0]。 */
          /* 🔴 直接把第 1 页那张已经**解码好**的 img 搬过来，不新建、不克隆。
             新建 img 就算同一个 URL 也要重新走一遍解码 ⇒ 用户滑过来看到的是"顶部一条 + 下面白块"
             （22:1x 实测，loaded:false）。搬移零成本，滑过去立刻就是完整画面。
             视频卡的这个 img 在第 1 页本来就被 display:none 藏着，搬走不影响视频页。 */
          var srcImg = reel.querySelector('.reel__pane img');
          var shot = document.createElement('div');
          shot.className = 'reel__pane reel__pane--shot';
          if (srcImg) {
            /* 🔴 体积：CDN 实测同一张卡 width=600 是 768KB、width=300 是 220KB（format=webp 被忽略）。
               768KB 在国内网络要 10 秒才解码完（实测 10353ms），那就是用户看到的白块。
               第 2 页只是"看清楚这张卡"，400 宽在手机上足够，体积降到 ~350KB、等待时间砍一半以上。 */
            var _src = srcImg.getAttribute('src') || srcImg.getAttribute('data-src') || '';
            if (_src) {
              _src = _src.replace(/([?&])width=\d+/, '$1width=400');
              if (!/width=\d+/.test(_src)) _src += (_src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
              srcImg.src = _src;
            }
            srcImg.style.opacity = '1';
            /* 🔴 CDN 给的是 535KB 的 PNG（?format=webp 被忽略），真机上解码要 1~3 秒，
               这段时间用户看到的就是一块白。垫一层「视频封面」当前景占位 ——
               它是个缩略图、早就加载好了，视觉上不会开天窗。 */
            var vd = reel.querySelector('video');
            var pst = vd && (vd.getAttribute('poster') || vd.getAttribute('data-poster'));
            if (pst) {
              shot.style.backgroundImage = 'url("' + pst.replace(/"/g, '%22') + '")';
              shot.style.backgroundSize = 'cover';
              shot.style.backgroundPosition = 'center';
            }
            shot.appendChild(srcImg);       /* appendChild 会自动从原位置移走 */
            reel.__track.appendChild(shot);
          }
        }
        /* 侯哥 22:0x：「左右滑动只留视频和图片滑动，详情不要」——
           这一段原来还会补「图集第 2 张起」和「详情页」，现在全部去掉，
           只保留上面那一张商品图。视频卡 2 页、图片卡 1 页（滑不动）。 */
        var dots = reel.__dots;
        if (dots) {
          var n = reel.__track.children.length, html = '';
          for (var k = 0; k < n; k++) html += '<i' + (k === 0 ? ' class="on"' : '') + '></i>';
          dots.innerHTML = html;
        }
      })
      .catch(function () { /* 拉不到就保持单页，不报错 */ });
  }

  /* ---------- 注入 + 跟着滚动补 ---------- */
  var feed = null;
  function ensureAll() {
    if (!feed) feed = document.getElementById('reelsFeed');
    if (!feed) return;
    var reels = feed.querySelectorAll('.reel');
    for (var i = 0; i < reels.length; i++) build(reels[i]);
  }

  function boot() {
    ensureAll();
    syncShip();
    /* 打开后 600ms 再补一遍：首次打开时相邻卡可能还没完成布局（被 height>200 闸门跳过），
       补这一遍让「下一张」在滑进来之前就把位置写好，翻页时就不会先低后跳。 */
    setTimeout(function () {
      /* 全量补位只在打开后跑一次（500 次 DOM 查询放每 1.5s 的循环里就是卡顿源） */
      try { placeAllBars(); } catch (e) {}
      syncShip();
    }, 600);
    setInterval(syncShip, 1500);
    var cacheW = function () {
      var f = document.getElementById('reelsFeed');
      if (!f) return;
      var rs = f.querySelectorAll('.reel');
      for (var i = 0; i < rs.length; i++) {
        var t = rs[i].__track;
        if (t) rs[i].__tw = t.clientWidth;
      }
    };
    setTimeout(cacheW, 800);
    window.addEventListener('resize', function () { setTimeout(cacheW, 260); });
    // JS 现拼的卡（从合集 JSON 拉的那种）在打开后陆续插进来 ⇒ 盯着 feed 补注入
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { ensureAll(); });
      var t = setInterval(function () {
        var f = document.getElementById('reelsFeed');
        if (f) { clearInterval(t); feed = f; ensureAll(); mo.observe(f, { childList: true, subtree: false }); }
      }, 400);
      setTimeout(function () { clearInterval(t); }, 30000);
    }
    // 关掉抽屉时如果还在滚，收起
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var s = document.getElementById('rsocSheet');
        if (s && s.__close) s.__close();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ============================================================================
   FOLLOW-PANEL-LIVE-20261029（侯哥 01:08「上线关注按钮」）
   卡面右上角「头像＋加号」→ 英文关注面板。
   · 位置用容器内坐标（offsetTop）算，与滚动无关 ⇒ 每一页在创建时就是准的（同社交栏的教训）
   · 面板是一份静态 DOM（Liquid 渲染，文案来自 section settings），这里只负责开关与关注态
   ============================================================================ */
(function () {
  /* FOLLOW-PLACE-20261029 v2（侯哥 01:33「为什么关注位置不一样／切换不丝滑／按钮错位」）
     上一版三个错：
       ① 只算一次就冻结 —— 但那一刻卡片布局往往还没稳定，量到的是上一张的值，于是永久错位（他两张图差了 38px）。
       ② 逐帧循环遍历 500 张卡、各自读 offsetHeight ⇒ 每帧强制重排，滑动直接卡。
       ③ 全量扫描和 reel-social 的定位循环抢主线程。
     ⇒ 改成：只看当前页 ±1 三张；每次都重算并写（容器内坐标与滚动无关，值稳定 ⇒ 写入不会产生可见跳动）；
        用 __t 缓存避免重复写样式；打开后只补 30 帧，之后靠「停手 120ms」的 scroll 回调自愈。 */
  /* 关注头像搬进卡片；并把 .reel__tap 一起搬进去 —— 它 z-index:2 且是 .reel 的兄弟，
     会把卡片内的按钮全部盖住（点击被它吃掉）。搬进卡片后：点空白仍暂停，点按钮就是按钮。 */
  function place() {
    var feed = document.getElementById('reelsFeed');
    if (!feed) return;
    var btns = feed.querySelectorAll('.reel__fol');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.__moved) continue;
      var r = btn.closest('.reel');
      var c = r && r.querySelector('.reel__card');
      if (!c) continue;
      var tap = r.querySelector('.reel__tap');
      if (tap && tap.parentElement !== c) c.appendChild(tap);
      c.appendChild(btn);
      btn.__moved = 1;
      btn.setAttribute('data-placed', '1');
    }
  }

  function applyFollowed(on) {
    var btns = document.querySelectorAll('.reel__fol');
    for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('is-followed', on);
    var ctas = document.querySelectorAll('.bbfol__cta');
    for (var j = 0; j < ctas.length; j++) {
      ctas[j].classList.toggle('is-followed', on);
      var sp = ctas[j].querySelector('span');
      if (sp) sp.textContent = on ? 'Following · 10% off applied' : (ctas[j].getAttribute('data-label') || sp.textContent);
    }
  }

  var KEY = 'bb_followed_v1';

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest && e.target.closest('[data-fol-open]');
    if (openBtn) {
      e.preventDefault(); e.stopPropagation();
      var fol = document.getElementById('bbFol');
      if (fol) {
        fol.classList.add('on');
        fol.setAttribute('aria-hidden', 'false');
        document.body.classList.add('locked');
      }
      return;
    }
    if (e.target.closest && e.target.closest('[data-fol-close]')) {
      e.preventDefault(); e.stopPropagation();
      var f2 = document.getElementById('bbFol');
      if (f2) {
        f2.classList.remove('on');
        f2.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('locked');
      }
      return;
    }
    var fl = e.target.closest && e.target.closest('[data-fol-follow]');
    if (fl) {
      e.preventDefault(); e.stopPropagation();
      try { localStorage.setItem(KEY, '1'); } catch (err) {}
      applyFollowed(true);
    }
  }, true);

  function boot() {
    place();
    var ctas = document.querySelectorAll('.bbfol__cta');
    for (var i = 0; i < ctas.length; i++) {
      var sp = ctas[i].querySelector('span');
      if (sp && !ctas[i].getAttribute('data-label')) ctas[i].setAttribute('data-label', sp.textContent);
    }
    var saved = false;
    try { saved = localStorage.getItem(KEY) === '1'; } catch (err) {}
    if (saved) applyFollowed(true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('resize', place, { passive: true });
  setInterval(place, 1200);

  /* 打开后只补 30 帧（约 0.5s），足够等布局稳定，又不会一直霸占主线程 */
  var _n = 0;
  (function tick() { place(); if (_n++ < 30) requestAnimationFrame(tick); })();

  /* REEL-FOL-DYNAMIC-20261029：搜索页进入 / 合集切换会把 #reelsFeed 整块重建，
     新插进来的关注按钮还没被搬进卡片（会错位露在卡外），这里盯 childList 立刻补搬，
     不用等 setInterval 那 1.2s 兜底。只监听直接子节点增删，不挂子树，避免高频触发。 */
  (function bindFeedRebuild() {
    var feed = document.getElementById('reelsFeed');
    if (!feed || feed.__folRebuild) return;
    feed.__folRebuild = 1;
    var t = null;
    try {
      new MutationObserver(function () {
        clearTimeout(t); t = setTimeout(place, 60);
      }).observe(feed, { childList: true });
    } catch (e) {}
  })();

  /* 翻页停下 120ms 后自愈一次：滑到哪张，那张（含邻居）位置一定是准的 */
  (function bindSettle() {
    var feed = document.getElementById('reelsFeed');
    if (!feed || feed.__folBound) return;
    feed.__folBound = 1;
    var t = null;
    feed.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(place, 120);
    }, { passive: true });
  })();
})();
